<!-- pdf 预览模式 -->
<template>
  <div>
    <div class="top_bag">
      <div class="system">
        <div class="organName">{{ mes.org_name }}</div>
        <div class="systemName">{{ name_system }}</div>
      </div>
    </div>
    <div class="pdf_top_bg">
      <div class="pdf_top w">
        <div class="lang_page">
          <span class="lang"
            >语种：{{ get_ch_name(fromLang) }}-> {{ get_ch_name(toLang) }}</span
          >
          <!-- <div class="page">
            <span>页码:</span>
            <div class="page_num_wrap">
             

              <el-input
                v-model="inputPage"
                placeholder="请输入内容"
                class="page_num_input"
                size="mini"
                @change="changeInputPage"
                @keyup.enter.native="enterBlur($event)"
                :disabled="transPic_filter_data.length < 1"
              ></el-input>
            
            </div>
            <span>/{{ pageNum }}</span>
          </div> -->
        </div>

        <!-- 头部右侧功能按钮 -->
        <div class="rignt_btn">
          <!-- <div class="right_btn_item" @click="share" v-if="showShare">
            <span class="iconfont icon-fenxiang"></span>
            分享
          </div> -->

          <div class="right_btn_item">
            <el-cascader
              v-model="cascaderValue"
              :options="typeOptions"
              @change="handleDownloadType($event)"
              size="mini"
              class="z-index"
              ref="cascader"
            ></el-cascader>
            <span class="pdf_xiazai">
              <i class="iconfont icon-xiazai"></i>下载</span
            >

            <!-- <el-dropdown>
                            <span> <i class="iconfont icon-xiazai"></i>下载</span>

                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item><span style="padding:0 14px" @click="handleDownLoad('translate')">下载译文</span></el-dropdown-item>
                                <el-dropdown-item><span style="padding:0 14px" @click="handleDownLoad('origin')">下载原文</span></el-dropdown-item>

                            </el-dropdown-menu>

                                                        </el-dropdown> -->
          </div>

          <!-- <div class="right_btn_item" @click="changeOrder">
                        <span class="iconfont icon-paixu-zuoyou"></span>
                        互换位置
                                                    </div> -->

          <div
            class="right_btn_item"
            @click="handleShowToLang"
            v-show="showFromPDF && showToPDF"
          >
            <span class="iconfont icon-fanyi"></span>
            只看译文
          </div>
          <div
            class="right_btn_item"
            @click="handleShowFromLang"
            v-show="showFromPDF && showToPDF"
          >
            <span class="iconfont icon-yuan"></span>
            只看原文
          </div>
          <div class="right_btn_item" @click="biger_all()" v-if="showToPDF && showFromPDF">
            <span class="iconfont icon-fangda1"></span>
            放大
          </div>

          <div class="right_btn_item" @click="smaller_all()" v-if="showToPDF && showFromPDF">
            <span class="iconfont icon-suoxiao1"></span>
            缩小
          </div>
          <!-- 译文放大 -->
          <div
            class="right_btn_item"
            @click="biger('trans_scale_factor')"
            v-if="showToPDF && !showFromPDF"
          >
            <span class="iconfont icon-fangda1"></span>
            放大
          </div>
          <!-- 译文缩小 -->
          <div
            class="right_btn_item"
            @click="smaller('trans_scale_factor')"
            v-if="showToPDF && !showFromPDF"
          >
            <span class="iconfont icon-suoxiao1"></span>
            缩小
          </div>
          <!-- 原文放大 -->
          <div
            class="right_btn_item"
            @click="biger('orgin_scale_factor')"
            v-if="!showToPDF && showFromPDF"
          >
            <span class="iconfont icon-fangda1"></span>
            放大
          </div>
          <!-- 原文缩小 -->
          <div
            class="right_btn_item"
            @click="smaller('orgin_scale_factor')"
            v-if="!showToPDF && showFromPDF"
          >
            <span class="iconfont icon-suoxiao1"></span>
            缩小
          </div>
        </div>
      </div>
    </div>
    <div class="num">
      <span v-if="modiList.length > 0">文章修改:{{ modiList.length }}</span>
      <span v-if="NodeList.length > 0">批注添加:{{ NodeList.length }}</span>
      <span v-if="mergeList.length > 0">合并语句:{{ mergeList.length }}</span>
    </div>
    <!-- 使用html 格式返回 -->
    <div class="html_wrap">
      <!--  v-loading="loading" element-loading-text="加载中" -->
      <div
        class="html_inner_wrap"
        :class="!showFromPDF || !showToPDF ? 'center' : ''"
        id="splitDragBox1"
      >
        <!-- 左侧缩略图导航栏 -->
        <!-- <div
          class="thumb_side"
          v-if="thumbFlag"
          ref="thumb_box"
          @mouseenter="enterThumb"
        >
          <ul class="view_list">
            <li
              class="img_box"
              :class="inputPage == index + 1 ? 'cur' : ''"
              v-for="(item, index) in thumbImg"
              :key="index"
              @click="handleThumb(index)"
              :id="`thumb${index}`"
            >
              <img :src="item" alt="" />
            </li>
          </ul>
        </div> -->

       


        <!-- 原文 -->
        <ul
          class="source_wrap"
          :class="boxChooseFlag ? 'no_select' : ''"
          v-show="showFromPDF"
          :style="{ width: !showToPDF ? html_w * zoom + 'px' : '' }"
          id="splitDragDown1"
        >
          <!-- 缩略图切换的按钮 -->
          <!-- <div
            class="thumb_btn"
            @click="switchThumb"
            v-if="showFromPDF && !showToPDF"
          >
            <span
              class="iconfont icon-triangle"
              :class="thumbFlag ? 'thumb_icon' : ''"
            ></span>
          </div> -->

          <li class="title">
            <div class="title_l"><span class="line"></span>原文</div>
            <div class="title_r">
              <!-- <el-tooltip
                class="item"
                effect="dark"
                content="缩小"
                placement="top"
                v-if="showToPDF && showFromPDF"
              >
                <span
                  class="iconfont icon-suoxiao1"
                  @click="smaller('orgin_scale_factor')"
                ></span>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="放大"
                placement="top"
                v-if="showToPDF && showFromPDF"
              >
                <span
                  class="iconfont icon-fangda1"
                  @click="biger('orgin_scale_factor')"
                ></span>
              </el-tooltip> -->

              <!-- <el-tooltip class="item" effect="dark" content="绘制区域" placement="top">
                                <span class="iconfont icon-huizhiquyu drawAreaIcon" :class="boxChooseFlag?'drawActive':''" @click="drawArea"></span>
                                                            </el-tooltip> -->
            </div>
          </li>
          <!-- dbClickEdit(index + 1, $event, 'origin') -->
          <li
            class="html_main"
            infinite-scroll-disabled="disabled"
            infinite-scroll-distance="400"
            ref="orgin_pdf"
            id="orgin_main"
            v-loading="orgin_loading" element-loading-text="原文加载中" 
          >
            <div
              class="htmlWrap"
              :style="{ zoom: zoom }"
              :class="showFromPDF && showToPDF ? 'white' : ''"
              :id="'orgin1'"
              ref="htmlWrap"
              @mouseenter="enterOrgin(1, $event)"
              @mousewheel="ctrlScale"
            >
              <div id="pdf-viewer_" style="text-align: center"></div>
            </div>
          </li>
          <!-- <li
            class="html_main"
            v-infinite-scroll="getHTML"
            infinite-scroll-disabled="disabled"
            infinite-scroll-distance="400"
            ref="orgin_pdf"
            id="orgin_main"
          >
            <div
              v-for="(item, index) in orginPic_filter_data"
              :key="index"
              class="htmlWrap"
              :style="{ zoom: zoom }"
              :class="showFromPDF && showToPDF ? 'white' : ''"
              :id="'orgin' + index"
              @mousedown="
                dragMove('orgin' + index, '.orginHtml', 'orgin', index)
              "
              ref="htmlWrap"
              @click="handleOrgin(index, $event)"
              @mouseenter="enterOrgin(index, $event)"
              @mousewheel="ctrlScale"
              @contextmenu.prevent="openMenu(item.index, $event, 'orgin')"
            >
              <div
                v-html="item.html"
                class="orginHtml"
                :style="{
                  transform: 'scale(' + orgin_scale_factor + ')',
                  height:
                    orgin_scale_factor < 1
                      ? orgin_scale_factor * html_h + 'px'
                      : '',
                  'max-height':
                    showFromPDF && showToPDF ? min * html_h + 'px' : '',
                  'transform-origin-x': origin_x + 'px',
                  'transform-origin-y': origin_y + 'px',
                }"
                @mouseover="highlight"
              ></div>
            </div>
          </li> -->
        </ul>

        
        <!-- 中间拖拽的分割条 -->
        <div
          id="splitDragResize1"
          class="splitDragResize"
          v-show="showFromPDF && showToPDF"
        ></div>
 <!-- 译文 -->
 <ul
          class="trans_wrap"
          v-show="showToPDF"
          :style="{
            order: order,
            width: !showFromPDF ? html_w * zoom + 'px' : '',
          }"
          id="splitDragTop1"
        >
          <!-- 缩略图切换的按钮 -->
          <!-- <div class="thumb_btn" @click="switchThumb">
            <span
              class="iconfont icon-triangle"
              :class="thumbFlag ? 'thumb_icon' : ''"
            ></span>
          </div> -->

          <li class="title">
            <div class="title_l"><span class="line"></span>译文</div>
            <div class="title_r">
              <!-- <el-tooltip
                class="item"
                effect="dark"
                content="缩小"
                placement="top"
                v-if="showToPDF && showFromPDF"
              >
                <span
                  class="iconfont icon-suoxiao1"
                  @click="smaller('trans_scale_factor')"
                ></span>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="放大"
                placement="top"
                v-if="showToPDF && showFromPDF"
              >
                <span
                  class="iconfont icon-fangda1"
                  @click="biger('trans_scale_factor')"
                ></span>
              </el-tooltip> -->
              <!-- <el-tooltip class="item" effect="dark" content="编辑译文" placement="top">
                                <span class="iconfont icon-beizhu" @click="editTranslation('trans_scale_factor')"></span>
                                                            </el-tooltip> -->

              <!-- 合并 -->
              <!-- <el-tooltip class="item" effect="dark" content="确认提交" placement="top">
                                <span class="iconfont icon-beizhu" @click="subConfirmation()"></span>
                                                </el-tooltip> -->
            </div>
          </li>
          <!-- html内容 -->
          <!-- dbClickEdit(index + 1, $event, 'translate') -->
          <li
            class="html_main"
            v-infinite-scroll="getHTML"
            infinite-scroll-disabled="disabled"
            infinite-scroll-distance="400"
            ref="trans_pdf"
            id="transWrap"
            
            v-loading="trans_loading" element-loading-text="译文加载中" 
          >
            <div
              class="htmlWrap"
              :style="{ zoom: zoom }"
              :class="showFromPDF && showToPDF ? 'white' : ''"
              :id="'trans1'"
              ref="htmlWrap"
              @mouseenter="enterTrans(1, $event)"
              @mousewheel="ctrlScale"
            >
              <div id="pdf-viewer" style="text-align: center"></div>
            </div>
            <!-- <div
              v-for="(item, index) in transPic_filter_data"
              :key="index"
              class="htmlWrap"
              :style="{ zoom: zoom }"
              :class="showFromPDF && showToPDF ? 'white' : ''"
              @mousedown="dragMove('trans' + index, '.transHtml', 'trans')"
              :id="'trans' + index"
              ref="htmlWrap"
              @click="chooseParagraph(index + 1, $event)"
              @contextmenu.prevent="openMenu(item.index, $event, 'trans')"
              @mouseenter="enterTrans(index, $event)"
              @mousewheel="ctrlScale"
            >
              <div
                v-html="item.html"
                class="transHtml"
                :style="{
                  transform: 'scale(' + trans_scale_factor + ')',
                  height:
                    trans_scale_factor < 1
                      ? trans_scale_factor * html_h + 'px'
                      : '',
                  'max-height':
                    showFromPDF && showToPDF ? min * html_h + 'px' : '',
                  'transform-origin-x': trans_x + 'px',
                  'transform-origin-y': trans_y + 'px',
                }"
                @mouseover="highlight"
              ></div>
            </div> -->
          </li>
        </ul>

      </div>
    </div>

    <!-- 右侧固定弹框 -->

    <div class="fixed_wrap" v-show="!showFromPDF || !showToPDF">
      <div class="show_to_lang" @click="handleShowAllLang">
        <span class="iconfont icon-zhankai"></span>
        <p>对照阅读</p>
      </div>
      <div
        class="show_from_lang"
        v-if="!showFromPDF"
        @click="handleShowFromLang"
      >
        <span class="iconfont icon-baocunbuju"></span>
        <p>原文</p>
      </div>
      <div
        class="show_from_lang"
        v-if="showFromPDF && !showToPDF"
        @click="handleShowToLang"
      >
        <span class="iconfont icon-baocunbuju"></span>
        <p>译文</p>
      </div>
    </div>

    <!-- 手机二维码弹框 -->

    <el-dialog
      :visible.sync="codeDialogVisible"
      width="22%"
      center
      :close-on-click-modal="false"
    >
      <div class="code_wrap">
        <img src="../../assets/imgs/code.jpg" alt="" class="code_img" />
        <p>使用微信扫一扫，手机阅读更方便！</p>
      </div>
    </el-dialog>

    <!-- 问题反馈的弹框 -->
    <el-dialog
      title="问题反馈"
      :visible.sync="formDialogVisible"
      width="40%"
      center
      :close-on-click-modal="false"
    >
      <el-form label-width="100px" :model="form" ref="feedbackForm">
        <el-form-item label="您遇到的问题">
          <el-select v-model="value" placeholder="请选择问题">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="其他">
          <el-input
            v-model="form.p_b"
            type="textarea"
            placeholder="在此输入您遇到的其他问题或描述具体问题情况"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传问题截图">
          <el-upload
            class="upload-demo"
            :action="action_url"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            multiple
            :limit="3"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :on-change="handleChange"
            name="img_obj"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            :on-error="uploadFail"
            :data="upload_params"
            :headers="myHeaders"
            ref="upload"
            :accept="accept"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="邮箱"
          prop="email"
          :rules="[
            { required: true, message: '请输入邮箱地址', trigger: 'blur' },
            {
              type: 'email',
              message: '请输入正确的邮箱地址',
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item label="QQ">
          <el-input v-model="form.qq"></el-input>
        </el-form-item>
        <el-form-item label="" class="switch_item">
          <el-checkbox v-model="form.allow">允许管理员查看文档内容</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="formDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('feedbackForm')"
          >提交</el-button
        >
      </span>
    </el-dialog>

    <!-- 反馈成功的提示框 -->
    <el-dialog
      title="提示"
      :visible.sync="dialog_feedback"
      width="400px"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <span class="iconfont icon-chenggong icon_sus"></span>
      <span class="upload_dianlog_h3">{{ feedback_txt }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialog_feedback = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="dialog_error"
      width="30%"
      :close-on-click-modal="false"
    >
      <div>
        <span class="iconfont icon-cuowu"></span>
        <span class="dialog_error">{{ error_txt }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialog_error = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 备注 -->
    <el-dialog
      title="备注"
      :visible.sync="dialog_note"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="dialog_note_title">
        <div class="dialog_note_title_l">批注</div>
        <div class="dialog_note_title_r" v-if="has_node_txt">
          <span class="iconfont icon-bianji" @click="editNote"></span>
          <span class="iconfont icon-shanchu" @click="delNote"></span>
        </div>
      </div>
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入批注内容"
        v-model="textarea_note"
        class="el_textarea"
        :disabled="textarea_note_disable"
      >
      </el-input>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitNode">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 在线编辑译文 -->
    <el-dialog
      title="在线编辑"
      :visible.sync="dialog_edit"
      width="40%"
      :close-on-click-modal="false"
    >
      <div class="dialog_note_title">
        <div class="dialog_note_title_l">编辑译文</div>
        <div class="dialog_note_title_r">
          <span class="iconfont icon-bianji" @click="canEditTrans"></span>
        </div>
      </div>
      <el-input
        type="textarea"
        placeholder="请输入批注内容"
        v-model="textarea_edit"
        class="el_textarea"
        :disabled="textarea_edit_disable"
        autosize
      >
      </el-input>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitEdit">确认修改</el-button>
      </span>
    </el-dialog>

    <!-- 合并下一句 -->
    <el-dialog
      title="合并下一句"
      :visible.sync="dialog_merge"
      width="40%"
      :close-on-click-modal="false"
    >
      <template v-if="!merge_loading">
        <div class="dialog_merge_box">
          <div class="dialog_merge_title">确认合并以下段落</div>
          <div class="merge_p">
            段落1：
            <span>{{ merge_pre }}</span>
          </div>
          <div class="merge_p">
            段落2：
            <span>{{ merge_next }}</span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialog_merge = false">取 消</el-button>
          <el-button type="primary" @click="merge_sure">确 定</el-button>
        </span>
      </template>

      <template v-else>
        <p class="merge_loading_p">正在合并，请稍等...</p>
      </template>
    </el-dialog>

    <!-- 修改译文 -->
    <el-dialog
      title="修改译文"
      :visible.sync="dialog_yiwen"
      width="40%"
      :close-on-click-modal="false"
    >
      <template>
        <div class="dialog_merge_box">
          <el-input
            type="textarea"
            :rows="10"
            placeholder="请输入内容"
            v-model="yiwen_textarea"
          >
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialog_yiwen = false">取 消</el-button>
          <el-button type="primary" @click="yiwen_sure()">确 定</el-button>
        </span>
      </template>

      <!-- <template v-else>
                <p class='merge_loading_p'>正在合并，请稍等...</p>
            </template> -->
    </el-dialog>

    <!-- 分享该页面 -->
    <el-dialog
      title="分享"
      :visible.sync="dialog_share"
      width="40%"
      :close-on-click-modal="false"
    >
      <span class="share_title">请复制以下链接分享该页面</span>
      <div class="share_link_box">
        <span>{{ share_link }}</span>
        <span
          class="copy-code-button"
          :data-clipboard-text="share_link"
          @click="copy"
          ><span class="iconfont icon-fuzhi"></span
        ></span>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialog_share = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- <ComFooter></ComFooter> -->
    <ul
      v-show="rightMenuVisible"
      :style="{ left: left + 'px', top: top + 'px' }"
      class="contextmenu"
    >
      <li @click="openFullScreen" v-if="showFromPDF && showToPDF">
        <span class="iconfont icon-quanping"></span>全屏
      </li>
    </ul>
    <!-- 全屏操作 -->
    <div class="mod-pop-doc" v-if="fullScreenFlag">
      <!-- 显示上一页 -->
      <el-tooltip class="item" effect="dark" content="上一页" placement="top">
        <div class="btn-page-prev" @click="prevPage">
          <span class="iconfont icon-xiangzuo1"></span>
        </div>
      </el-tooltip>
      <!-- 下一页 -->
      <el-tooltip class="item" effect="dark" content="下一页" placement="top">
        <div class="btn-page-next" @click="nextPage">
          <span class="iconfont icon-xiangzuo1"></span>
        </div>
      </el-tooltip>
      <!-- 关闭 -->
      <el-tooltip class="item" effect="dark" content="关闭" placement="left">
        <div class="btn-close" @click="closePop">
          <span class="iconfont icon-guanbi1"></span>
        </div>
      </el-tooltip>
      <!--  -->
      <div class="group">
        <!-- 放大 -->
        <el-tooltip class="item" effect="dark" content="放大" placement="left">
          <div class="btn-big" @click="popBig">
            <span class="iconfont icon-fangda"></span>
          </div>
        </el-tooltip>
        <!-- 缩小 -->
        <el-tooltip class="item" effect="dark" content="缩小" placement="left">
          <div class="btn-small" @click="popSmall">
            <span class="iconfont icon-suoxiao"></span>
          </div>
        </el-tooltip>

        <!-- 旋转 -->
        <el-tooltip class="item" effect="dark" content="旋转" placement="left">
          <div class="btn-rotate" @click="popRotate">
            <span class="iconfont icon-xuanzhuan"></span>
          </div>
        </el-tooltip>
        <!-- 切换译文和原文 -->
        <el-tooltip
          class="item"
          effect="dark"
          :content="rightMenuType == 'orgin' ? '切换至译文' : '切换至原文'"
          placement="left"
        >
          <div class="btn-change" @click="changePopType">
            <span
              class="iconfont icon-yuanyiwenqiehuan2"
              v-if="rightMenuType == 'trans'"
            ></span>
            <span
              class="iconfont icon-yuanyiwenqiehuan"
              v-if="rightMenuType == 'orgin'"
            ></span>
          </div>
        </el-tooltip>
      </div>
      <!-- 译文或原文主体部分 -->
      <div class="pop-con" ref="pop_con">
        <ul
          class="view-list"
          v-infinite-scroll="getHTML"
          infinite-scroll-disabled="disabled"
          infinite-scroll-distance="400"
          :style="{ width: html_w * fullScrenZoom + 'px' }"
        >
          <!-- 显示译文 -->
          <template v-if="rightMenuType == 'trans'">
            <li
              class="img-box"
              v-for="(item, index) in transPic_filter_data"
              :key="index"
              :style="{ zoom: fullScrenZoom }"
              :id="'img-box-' + item.index"
            >
              <div v-html="item.html"></div>
              <div class="pageNum">{{ item.index }}</div>
            </li>
          </template>

          <!-- 显示原文 -->
          <template v-if="rightMenuType == 'orgin'">
            <li
              class="img-box"
              v-for="(item, index) in orginPic_filter_data"
              :key="index"
              :style="{ zoom: fullScrenZoom }"
              :id="'img-box-' + item.index"
            >
              <div v-html="item.html"></div>
              <div class="pageNum">{{ item.index }}</div>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import * as pdfjsLib from "pdfjs-dist";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
import Clipboard from "clipboard";
import splitScreen from "../../utils/splitScreen.js";
// import qs from "qs";
// import $ from "jquery";
import { getLanguages_ql, download_ql } from "@/Api/translation";
export default {
  data() {
    return {
      page: 1, // 当前页码
      codeDialogVisible: false,
      formDialogVisible: false,
      form: {
        p_b: "",
        email: "",
        task_id: null,
        qq: null,
        allow: true,
      },
      // 反馈图片的参数
      upload_params: {
        task_id: null,
      },
      options: [
        {
          value: "语种识别有误",
          label: "语种识别有误",
        },
        {
          value: "未作翻译",
          label: "未作翻译",
        },
        {
          value: "乱码现象",
          label: "乱码现象",
        },
        {
          value: "文字堆叠",
          label: "文字堆叠",
        },
        {
          value: "版式错乱严重",
          label: "版式错乱严重",
        },
      ],
      value: "语种识别有误",
      sub_flag: true, //确认按钮节流阀
      dialog_yuanwen: false, //修改页面原文弹框
      dialog_yiwen: false, //修改页面译文弹框
      yiwen_textarea: "", //修改译文弹框内容
      modil: {}, //修改页面的传参对象
      modiList: [], //修改页面的list集合

      NodeList: [], //添加备注的list

      mergeList: [], //合并下一句的参数list

      fileList: [], // 问题反馈的图片列表
      showFromPDF: true, // 显示原文
      showToPDF: true, // 显示译文
      orginPic: [], // 原始图片列表
      transPic: [], // 翻译图片列表
      scrollTarget: true, // 单侧滚动的标志
      pageNum: null, // 页面总数
      img_h: null,
      inputPage: 1, // 输入框的页码
      fromLang: "", // 来源语种
      toLang: "", // 目的语种
      myHeaders: { USID: JSON.parse(window.localStorage.getItem("usid")) },

      dialog_feedback: false,
      feedback_txt: null, // 反馈成功的提示语
      // action_url: 'http://192.168.66.121:9000/api/translate/feedback_img/',
      action_url: window.location.origin + "/api/translate/feedback_img/",
      accept: "image/jpeg, image/png,",

      box_w: 0, // 容器的宽度
      html_w: 0, // 返回的html的宽度
      html_h: 0, // 返回的html的高度
      scale_factor: 1, // html的缩放系数
      orgin_scale_factor: 1, // 原文的缩放系数
      trans_scale_factor: 1, // 译文的缩放系数
      before_factor: 1, // 显示页面的初始缩放系数
      loading: true,
      left: "47.8%",
      order: 0, // 原文和译文的位置
      dialog_error: false, // 数据返回错误的提示
      error_txt: "",
      html_loading: false,
      zoom: 1, // 原文或译文单独查看的缩放系数
      isFireFox: false, // 检测是否是火狐浏览器
      swapFlag: true, //是否互换位置
      singleScrollTop: 0,

      merge_id: null, // 要合并的当前id
      merge_next_id: null, // 合并的下一句的id
      addbox_top: -1000, // 备注按钮距离顶部的高度
      addbox_left: 0, // 备注按钮距离顶部的高度

      select_id: null, // 要添加备注的id
      db_select_id: null, // 在线编辑的id

      dialog_note: false, // 添加备注的弹框
      textarea_note: null, // 输入的备注信息
      textarea_note_disable: true, // 备注是否可编辑
      has_node_txt: false, // 当前标签是否存在备注信息
      init_note: null, // 返回的初始备注
      showAddbox: true, // 是否展示添加备注的按钮
      delFlag: true, // 删除备注的节流标志

      dialog_edit: false, // 编辑译文的弹框
      textarea_edit: null, // 输入在线修改的译文
      textarea_edit_disable: true, // 译文在线是否可编辑

      merge_page: null, // 当前合并下一句的页码
      dialog_merge: false,
      merge_pre: null, // 将要合并的上一句，
      merge_next: null, // 即将合并的下一句
      merge_info: null, // 合并预览返回的信息
      select_page: null, // 合并下一句选择的当前页码
      merge_loading: false, // 正在合并的loading

      share_id: null, // 生成的分享ID
      dialog_share: false, // 分享页面的弹框
      share_link: null, // 生成的分享链接
      showShare: true, // 是否显示分享按钮

      rightMenuVisible: false, // 自定义的右键菜单是否显示
      rightMenuType: null, // 右键译文还是原文
      top: 0, // 自定义右键菜单top位置
      left: 0, // 自定义右键菜单left位置

      jump_flag: false, // 是否是输入页码跳转的
      i: 0,
      go_top_post: true, // 向上滚动式是否可以发送请求
      ctrl_status: false, //ctrl是否是按下状态
      origin_x: 0, // 缩放原点的x坐标
      origin_y: 0, // 缩放原点的Y坐标
      trans_x: 0, // 缩放原点的x坐标
      trans_y: 0, // 缩放原点的Y坐标
      insertPage_flag: false, // 是否是直接插入页面不根据滚动高度计算当前页码
      handlePage: null, // 在线编辑的当前页

      // 监听DOM变化的相关变量
      observer: null,
      firedNum: 0,
      recordOldValue: {
        // 记录下旧的宽高数据，避免重复触发回调函数
        width: "0",
        height: "0",
      },

      // 缩略图相关变量
      thumbImg: [], // 缩略图列表
      thumbFlag: false, //是否显示左侧缩略图

      fullScreenFlag: false, // 是否显示全屏
      fullScrenZoom: 1, // 全屏模式下的缩放系数
      fullScreenPage: 1, // 全屏模式下的页码
      prevPageFlag: false,

      boxChoosePage: null, // 进行框选选区的操作的页码
      boxChooseFlag: false, // 是否进行框选选区的操作
      cascaderValue: null,
      typeOptions: [
        {
          value: "translate",
          label: "下载译文",
          children: [
            {
              value: "pdf",
              label: "PDF版",
            },
            {
              value: "word",
              label: "Word版",
            },
          ],
        },
        {
          value: "origin",
          label: "下载原文",
          // children: [
          //   {
          //     value: "pdf",
          //     label: "PDF版",
          //   },
          //   {
          //     value: "word",
          //     label: "word版",
          //   },
          // ],
        },
        {
          value: "compare",
          label: "下载对照版(除pdf中译英外)",
        },
      ],
      mes: {},
      options: [],
      task_id_copy: "",
      trans_loading:true,
      orgin_loading:true,
    };
  },
  created() {
    this.mes = JSON.parse(sessionStorage.getItem("mes"));
    console.log("cccccc");
    // console.log('aaaaaa',this.$route)
    this.fromLang = this.$route.query.langFrom;
    this.toLang = this.$route.query.langTo;
    this.task_id_copy = this.$route.query.task_id;
    console.log(this.fromLang);
    // this.pageNum = Number(this.$route.query.pageNum);

    // let i;
    // for (i = 0; i < this.pageNum; i++) {
    //   this.transPic.push({
    //     html: null,
    //     index: null,
    //   });
    //   this.orginPic.push({
    //     html: null,
    //     index: null,
    //   });
    // }
    // 获取HTML
    // this.getHTML();
    this.transDownLoad();

    //获取翻译的语种信息
    this.getLang();
    // this.getThumb();

    // // 账号登录的创建分享id,否则禁止分享
    // if (!this.$route.query.share_id) {
    //   // 创建分享Id
    //   this.creatShareId();
    // } else {
    //   this.showShare = false;
    // }
  },
  watch: {
    rightMenuVisible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },

  computed: {
    noMore() {
      return this.page > this.pageNum;
    },
    disabled() {
      return this.html_loading || this.noMore;
    },
    // 获取页面的最小缩放系数控制html 的最大高度，是两侧页面高度一致
    min() {
      return Math.min(this.orgin_scale_factor, this.trans_scale_factor);
    },
    transPic_filter_data() {
      return this.transPic.filter((item) => {
        return item.html;
      });
    },
    orginPic_filter_data() {
      return this.orginPic.filter((item) => {
        return item.html;
      });
    },
    name_system() {
      let industry_s = [
        "编辑部",
        "高校图工委",
        "医图委",
        "学协会",
        "公图",
        "本科学院",
        "本科实验室",
        "本科研究院",
        "医院科室",
        "课题组",
      ];
      if (this.mes.industry && this.mes.industry !== undefined) {
        if (industry_s.indexOf(this.mes.industry) >= 0) {
          return "青梨AI科研服务平台";
        } else {
          return "图书馆AI科研服务平台";
        }
      } else {
        return "青梨AI科研服务平台";
      }
    },
  },
  mounted() {
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    if (w < 1100) {
      this.left = "526px";
    } else {
      this.left = "47.8%";
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.img_h = document
          .querySelectorAll(".htmlWrap")[0]
          .getBoundingClientRect().height;
      }, 3000);
    });

    // 滚动条的获取
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, false);
    this.watchKeyEvent();

    setTimeout(() => {
      this.box_w =
        document.getElementsByClassName("source_wrap")[0].offsetWidth - 10;
      this.html_w = document.getElementById("pf1")
        ? document.getElementById("pf1").offsetWidth
        : 800;
      this.html_h = document.getElementById("pf1")
        ? document.getElementById("pf1").offsetHeight
        : 1200;

      // 返回的html 的尺寸大于容器，进行缩放，否则原尺寸显示

      if (this.html_w > this.box_w) {
        this.scale_factor = this.box_w / this.html_w;
        this.orgin_scale_factor = this.scale_factor;
        this.trans_scale_factor = this.scale_factor;

        console.log("this.orgin_scale_factor", this.orgin_scale_factor);
      } else {
        this.scale_factor = 1;
        this.orgin_scale_factor = 1;
        this.trans_scale_factor = 1;
      }
      this.before_factor = this.scale_factor;
    }, 0);

    //  禁止ctrl 加 鼠标滚轮控制网页缩放
    window.addEventListener(
      "mousewheel",
      function (event) {
        if (event.ctrlKey === true || event.metaKey) {
          event.preventDefault();
        }
      },
      { passive: false }
    );

    //firefox
    window.addEventListener(
      "DOMMouseScroll",
      function (event) {
        if (event.ctrlKey === true || event.metaKey) {
          event.preventDefault();
        }
      },
      { passive: false }
    );

    // 禁止ctrl 加 ‘+’ ‘-’ 控制网页缩放
    window.addEventListener(
      "keydown",
      function (event) {
        if (
          (event.ctrlKey === true || event.metaKey === true) &&
          (event.which === 61 ||
            event.which === 107 ||
            event.which === 173 ||
            event.which === 109 ||
            event.which === 187 ||
            event.which === 189)
        ) {
          event.preventDefault();
        }
      },
      false
    );

    // 拖拽分屏操作
    let splitScreenObj = new splitScreen({
      splitDragBox: "splitDragBox1",
      splitDragTop: "splitDragTop1",
      splitDragResize: "splitDragResize1",
      splitDragDown: "splitDragDown1",
    });
    splitScreenObj.dragControllerDiv();

    // 监听dom变化的相关操作
    let MutationObserver =
      window.MutationObserver ||
      window.WebKitMutationObserver ||
      window.MozMutationObserver;
    let element = document.querySelector(".trans_wrap");
    this.observer = new MutationObserver((mutationList) => {
      for (let mutation of mutationList) {
        // console.log(mutation)
      }
      let width = getComputedStyle(element).getPropertyValue("width");
      let height = getComputedStyle(element).getPropertyValue("height");
      if (
        width === this.recordOldValue.width &&
        height === this.recordOldValue.height
      )
        return;
      this.recordOldValue = {
        width,
        height,
      };

      if (this.showFromPDF && this.showToPDF) {
        // 修改缩放系数
        let w =
          document.documentElement.clientWidth || document.body.clientWidth;
        if (w < 1100) {
          this.left = "526px";
        } else {
          this.left = "47.8%";
        }
        setTimeout(() => {
          this.img_h = this.$refs.htmlWrap[0].offsetHeight;
        }, 1000);

        // this.box_w = document.getElementsByClassName('trans_wrap')[0].offsetWidth
        let trans_box_w =
          document.getElementsByClassName("trans_wrap")[0].offsetWidth;
        let source_box_w =
          document.getElementsByClassName("source_wrap")[0].offsetWidth;
        let max = Math.max(trans_box_w, source_box_w);

        this.html_w = document.getElementById("pf1").offsetWidth;
        // this.html_h = document.getElementById('pf1').getBoundingClientRect().height
        // console.log('变化了，',this.html_h)

        if (this.html_w > max) {
          this.scale_factor = max / this.html_w;
          this.orgin_scale_factor = this.scale_factor;
          this.trans_scale_factor = this.scale_factor;
        } else {
          // this.scale_factor = 1
          // this.orgin_scale_factor = 1
          // this.trans_scale_factor = 1

          this.scale_factor = max / this.html_w;
          this.orgin_scale_factor = this.scale_factor;
          this.trans_scale_factor = this.scale_factor;
        }
        this.before_factor = this.scale_factor;
      }
    });
    this.observer.observe(element, {
      attributes: true,
      attributeFilter: ["style"],
      attributeOldValue: true,
    });
  },
  beforeDestroyed() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer.takeRecords();
      this.observer = null;
    }
  },

  methods: {
    orginDownLoad() {
     
      download_ql({
        task_id: this.task_id_copy,
        type: "2",
      })
        .then((res) => {
          console.log(res);
          if (res.data.error_code == 0) {
            this.loadPDF(res.data.data.replace(/^http:\/\//, "https://"));

           
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    transDownLoad() {
      this.trans_loading = true;
      this.orgin_loading = true;
      download_ql({
        task_id: this.task_id_copy,
        type: "1", 
      })
        .then((res) => {
          console.log(res);
          if (res.data.error_code == 0) {
            this.loadPDF_(res.data.data.replace(/^http:\/\//, "https://"));
            this.orginDownLoad();
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 绘制区域
    drawArea() {
      this.boxChooseFlag = true;
    },

    // 框选选区
    boxChoose() {
      if (!this.boxChooseFlag) {
        return;
      }

      let that = this;
      var mouseStopId;
      var mouseOn = false;
      var startX = 0;
      var startY = 0;
      // 获取容器元素
      var wrap = document.getElementById("splitDragDown1"); // 原文区域的相对位置
      var selectContainer = document.getElementById("splitDragDown1");
      // var selectContainer = document.getElementById('orgin' + this.boxChoosePage);

      selectContainer.onmousedown = function (e) {
        clearEventBubble(e);
        if (e.buttons !== 1 || e.which !== 1) return;
        mouseStopId = setTimeout(function () {
          mouseOn = true;
          // 调整坐标原点为容器左上角
          startX =
            e.clientX - selectContainer.offsetLeft + selectContainer.scrollLeft;
          // startX = e.clientX - wrap.offsetLeft + selectContainer.scrollLeft;

          // startY = e.clientY + selectContainer.scrollTop - 220;
          startY =
            e.clientY -
            selectContainer.offsetTop +
            selectContainer.scrollTop -
            150;

          // console.log('startY', startY)
          // console.log('e.clientY', e.clientY)
          // console.log('wrap.offsetTop', wrap.offsetTop)
          // console.log('selectContainer.scrollTop', wrap.scrollTop)

          $("#selectDiv").remove(); // 删除之前创建的选择框

          var selDiv = document.createElement("div");
          selDiv.style.cssText =
            "position:absolute;width:0;height:0;margin:0;padding:0;border:1px dashed #eee;background-color:#aaa;z-index:1000;opacity:0.6;display:none;";
          selDiv.id = "selectDiv";
          // 添加框选元素到容器内
          // document.getElementById('orgin' + that.boxChoosePage).appendChild(selDiv);
          document.getElementById("splitDragDown1").appendChild(selDiv);

          selDiv.style.left = startX + "px";
          selDiv.style.top = startY + "px";
        }, 20);
        document.onmousemove = function (e) {
          if (!mouseOn) return;
          clearEventBubble(e);
          // var selectContainer = document.getElementById('orgin' + that.boxChoosePage);
          var selectContainer = document.getElementById("splitDragDown1");

          var _x = e.clientX - wrap.offsetLeft + selectContainer.scrollLeft;
          // var _y = e.clientY + selectContainer.scrollTop - 220;
          var _y = e.clientY + selectContainer.scrollTop - 150;

          var _H = selectContainer.offsetWidth;
          // 鼠标移动超出容器内部，进行相应的处理
          // 向右拖拽
          if (
            e.clientX >
            selectContainer.offsetLeft + selectContainer.offsetWidth
          ) {
            let maxLeft =
              selectContainer.scrollWidth - selectContainer.offsetWidth;
            let step = selectContainer.scrollLeft + 20;
            if (step >= maxLeft) {
              selectContainer.scrollLeft = maxLeft;
            } else {
              selectContainer.scrollLeft = step;
            }
          }
          // 向左拖拽
          if (e.clientX < selectContainer.offsetLeft) {
            let minLeft = 0;
            let step = selectContainer.scrollLeft - 20;
            if (step <= minLeft) {
              selectContainer.scrollLeft = minLeft;
            } else {
              selectContainer.scrollLeft = step;
            }
          }
          var selDiv = document.getElementById("selectDiv");
          selDiv.style.display = "block";
          selDiv.style.left = Math.min(_x, startX) + "px";
          selDiv.style.top = Math.min(_y, startY) + "px";
          if (
            Math.min(_x, startX) + Math.abs(_x - startX) <=
            selectContainer.scrollWidth
          ) {
            selDiv.style.width = Math.abs(_x - startX) + "px";
          }
          selDiv.style.height = Math.abs(_y - startY) + "px";
        };
        document.onmouseup = function (e) {
          if (!mouseOn) return;
          clearEventBubble(e);
          let selDiv = document.getElementById("selectDiv");
          // let fileDivs = document.querySelector('#orgin' + that.boxChoosePage).querySelectorAll('[type="origin"]');
          let fileDivs = document
            .querySelector("#splitDragDown1")
            .querySelectorAll('[type="origin"]');

          console.log("fileDivs", fileDivs);
          let selectedEls = [];

          let l = Math.floor(selDiv.offsetLeft / that.orgin_scale_factor);
          let t = Math.floor(selDiv.offsetTop / that.orgin_scale_factor) - 44; // 减去头部标题的高度
          let w = Math.floor(selDiv.offsetWidth / that.orgin_scale_factor);
          let h = Math.floor(selDiv.offsetHeight / that.orgin_scale_factor);
          console.log("左", l);
          console.log("上", t);
          console.log("宽", w);
          console.log("高", h);

          for (let i = 0; i < fileDivs.length; i++) {
            let sl = fileDivs[i].offsetWidth + fileDivs[i].offsetLeft;
            let st = fileDivs[i].offsetHeight + fileDivs[i].offsetTop;
            // var sl = fileDivs[i].getBoundingClientRect().width + fileDivs[i].offsetLeft;
            // var st = fileDivs[i].getBoundingClientRect().height + fileDivs[i].offsetTop;
            // console.log('fileDivs[i].getBoundingClientRect().width', fileDivs[i].getBoundingClientRect().width)
            // console.log('fileDivs[i].offsetLeft', fileDivs[i].offsetLeft)
            // console.log('fileDivs[i].getBoundingClientRect().left', fileDivs[i].getBoundingClientRect().left)

            // console.log('fileDivs[i].getBoundingClientRect().height', fileDivs[i].getBoundingClientRect().height)
            // console.log('fileDivs[i].offsetTop', fileDivs[i].offsetTop)
            // console.log('fileDivs[i].getBoundingClientRect().top', fileDivs[i].getBoundingClientRect().left)

            // console.log('fileDivs[i].offsetWidth', fileDivs[i].offsetWidth)
            // console.log(fileDivs[i].getBoundingClientRect().width)
            // console.log('fileDivs[i].offsetLeft', fileDivs[i].offsetLeft)
            // console.log(fileDivs[i].getBoundingClientRect().top)

            // console.log('t + h',t + h)
            if (
              sl > l &&
              st > t &&
              fileDivs[i].offsetLeft < l + w &&
              fileDivs[i].offsetTop < t + h
            ) {
              // console.log('选中了')
              fileDivs[i].style.background = "red";
              // console.log(fileDivs[i].style.background)
              selectedEls.push(fileDivs[i]);
              // console.log('文本内容是', fileDivs[i].innerText)
            }
          }
          // console.log(selectedEls);
          // selDiv.style.display = 'none';
          mouseOn = false;
        };
      };
      function clearEventBubble(e) {
        if (e.stopPropagation) e.stopPropagation();
        else e.cancelBubble = true;

        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
      }
    },

    // 滚动左侧缩略图到可视范围
    scrollThumbView() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.inputPage >= 2 && this.thumbFlag) {
            document
              .getElementById("thumb" + (this.inputPage - 2))
              .scrollIntoView();
          }
        }, 100);
      });
    },
    handleResize() {
      // 拖拽分屏操作
      let splitScreenObj = new splitScreen({
        splitDragBox: "splitDragBox1",
        splitDragTop: "splitDragTop1",
        splitDragResize: "splitDragResize1",
        splitDragDown: "splitDragDown1",
      });
      splitScreenObj.dragControllerDiv();

      let w = document.documentElement.clientWidth || document.body.clientWidth;
      if (w < 1100) {
        this.left = "526px";
      } else {
        this.left = "47.8%";
      }
      setTimeout(() => {
        this.img_h = this.$refs.htmlWrap[0].offsetHeight;
      }, 1000);

      // this.box_w = document.getElementsByClassName('source_wrap')[0].offsetWidth
      // this.html_h = document.getElementById('pf1').getBoundingClientRect().height
      // console.log('变化了，',this.html_h)

      // 强制复制为百分比

      if (
        document.getElementsByClassName("trans_wrap")[0].style.width &&
        this.showFromPDF &&
        this.showToPDF
      ) {
        document.getElementsByClassName("source_wrap")[0].style.width = "48%";
        document.getElementsByClassName("trans_wrap")[0].style.width = "48%";
      }
      if (this.showFromPDF && !this.showToPDF) {
        document.getElementsByClassName("source_wrap")[0].style.width = "auto";
      }
      if (!this.showFromPDF && this.showToPDF) {
        document.getElementsByClassName("trans_wrap")[0].style.width = "auto";
      }

      let trans_box_w =
        document.getElementsByClassName("trans_wrap")[0].offsetWidth;
      let source_box_w =
        document.getElementsByClassName("source_wrap")[0].offsetWidth;
      let max = Math.max(trans_box_w, source_box_w);
      this.html_w = document.getElementById("pf1").offsetWidth;

      if (this.html_w > max) {
        this.scale_factor = max / this.html_w;
        this.orgin_scale_factor = this.scale_factor;
        this.trans_scale_factor = this.scale_factor;
      } else {
        if (this.showFromPDF && this.showToPDF) {
          this.scale_factor = max / this.html_w;
          this.orgin_scale_factor = this.scale_factor;
          this.trans_scale_factor = this.scale_factor;
        } else {
          this.scale_factor = 1;
          this.orgin_scale_factor = 1;
          this.trans_scale_factor = 1;
        }
      }
      this.before_factor = this.scale_factor;
    },

    // 检测是否按下Ctrl按键
    watchKeyEvent() {
      const setKeyStatus = (keyCode, status) => {
        switch (keyCode) {
          case 16:
            if (this.onShfit === status) return;
            this.onShfit = status;
            break;
          case 17:
            if (this.onCtrl === status) return;
            this.ctrl_status = status;
            this.onCtrl = status;
            break;
        }
      };
      document.onkeydown = (e) => {
        setKeyStatus(e.keyCode, true);
      };
      document.onkeyup = (e) => {
        setKeyStatus(e.keyCode, false);
      };
    },

    // 按住Ctrl 和滚轮分别对原文和译文进行缩放
    ctrlScale(e) {
      // 同时按下了Ctrl 案件
      if (this.ctrl_status) {
        // 译文盒子距离浏览器左侧的距离
        let trans_distance_left = this.$refs.trans_pdf
          ? this.$refs.trans_pdf.getBoundingClientRect().left
          : 0;
        // 原文盒子距离浏览器左侧的距离
        let orgin_distance_left = this.$refs.orgin_pdf
          ? this.$refs.orgin_pdf.getBoundingClientRect().left
          : 0;
        // 译文和原文距离浏览器顶部的距离
        let distance_top;

        if (this.$refs.trans_pdf) {
          distance_top = this.$refs.trans_pdf.getBoundingClientRect().top;
        } else if (this.$refs.orgin_pdf) {
          distance_top = this.$refs.orgin_pdf.getBoundingClientRect().top;
        }

        if (e.wheelDelta) {
          //当鼠标滚轮向上滚动时
          if (e.wheelDelta > 0) {
            // 针对译文放大
            if (this.scrollTarget == "trans") {
              this.trans_x = e.x - trans_distance_left;
              this.trans_y = e.y - distance_top;
              this.biger("trans_scale_factor");
            }
            // 针对原文放大
            if (this.scrollTarget == "orgin") {
              this.origin_x = e.x - orgin_distance_left;
              this.origin_y = e.y - distance_top;
              this.biger("orgin_scale_factor");
            }
          }

          //当鼠标滚轮向下滚动时
          if (e.wheelDelta < 0) {
            // 针对译文缩小
            if (this.scrollTarget == "trans") {
              // 当前缩放系数小于初始页面的缩放系数的话禁止缩放

              if (this.trans_scale_factor <= this.before_factor + 0.1) {
                return;
              }
              // 缩放系数小于初始系数+0.4的情况将缩放原点设置为左上角

              if (this.trans_scale_factor <= this.before_factor + 0.4) {
                this.trans_x = 0;
                this.trans_y = 0;
              } else {
                // 以点击原点为缩放原点
                this.trans_x = e.x - trans_distance_left;
                this.trans_y = e.y - distance_top;
              }

              this.smaller("trans_scale_factor");
            }
            // 针对原文缩小
            if (this.scrollTarget == "orgin") {
              if (this.orgin_scale_factor <= this.before_factor + 0.1) {
                return;
              }
              if (this.orgin_scale_factor <= this.before_factor + 0.4) {
                this.origin_x = 0;
                this.origin_y = 0;
              } else {
                this.origin_x = e.x - orgin_distance_left;
                this.trans_y = e.x - distance_top;
              }

              this.smaller("orgin_scale_factor");
            }
          }
        } else if (e.detail) {
          //当鼠标滚轮向上滚动时
          if (e.detail < 0) {
            // 针对译文放大
            if (this.scrollTarget == "trans") {
              this.trans_x = e.x - trans_distance_left;
              this.trans_y = e.y - distance_top;
              this.biger("trans_scale_factor");
            }
            // 针对原文放大
            if (this.scrollTarget == "orgin") {
              this.origin_x = e.x - orgin_distance_left;
              this.origin_y = e.y - distance_top;
              this.biger("orgin_scale_factor");
            }
          }
          //当鼠标滚轮向下滚动时
          if (e.detail > 0) {
            // 针对译文缩小
            if (this.scrollTarget == "trans") {
              if (this.trans_scale_factor <= this.before_factor + 0.1) {
                return;
              }
              if (this.trans_scale_factor <= this.before_factor + 0.4) {
                this.trans_x = 0;
                this.trans_y = 0;
              } else {
                this.trans_x = e.x - trans_distance_left;
                this.trans_y = e.y - distance_top;
              }

              this.smaller("trans_scale_factor");
            }
            // 针对原文缩小
            if (this.scrollTarget == "orgin") {
              if (this.orgin_scale_factor <= this.before_factor + 0.1) {
                return;
              }
              if (this.orgin_scale_factor <= this.before_factor + 0.4) {
                this.origin_x = 0;
                this.origin_y = 0;
              } else {
                this.origin_x = e.x - orgin_distance_left;
                this.trans_y = e.x - distance_top;
              }

              this.smaller("orgin_scale_factor");
            }
          }
        }
      }
    },

    // 输入页码回车失去焦点
    enterBlur(event) {
      event.target.blur();
    },
    get_ch_name(val) {
      const option = this.options.find((option) => option.value === val);
      return option ? option.ch_name : ""; // 如果找不到返回 '未找到'
    },
    // 获取翻译语言
    getLang() {
      console.log("res", "aaaaaaaa");
      getLanguages_ql().then((res) => {
        console.log(res);
        if (res.data.error_code == 0) {
          this.options = res.data.data;
        } else {
          this.options = [];
        }
      });
      return;
      this.$http
        .get("translate/get_lang/", {
          params: {
            task_id: this.$route.query.id,
          },
        })
        .then((res) => {
          if (res.data.status == 0) {
            this.fromLang = res.data.data.langFrom;
            this.toLang = res.data.data.langTo;
          }
        })
        .catch((err) => {
          this.$message.error(err || "发生错误");
        });
    },

    // 显示自定义的右键内容
    openMenu(page, e, type) {
      this.rightMenuType = type;
      this.top = e.clientY;
      this.left = e.clientX;
      this.rightMenuVisible = true;
      this.select_page = page;
      this.select_id = e.target.getAttribute("fanyi");
      if (this.select_id) {
        let _dom = document.querySelector(
          `.trans_wrap [fanyi='${this.select_id}']`
        );

        this.merge_next_id = _dom.nextElementSibling
          ? _dom.nextElementSibling.getAttribute("fanyi")
          : null;
      }
    },
    // 关闭自定义的右键内容
    closeMenu() {
      this.rightMenuVisible = false;
    },

    // 生成分享Id
    creatShareId() {
      this.$http
        .post(
          "translate/share/",
          this.$qs.stringify({
            task_id: this.$route.query.id,
          })
        )
        .then((res) => {
          if (res.data.status == 0) {
            this.share_id = res.data.data.share_id;
            this.share_link = `${window.location.origin}/#${this.$route.fullPath}&share_id=${this.share_id}`;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },

    // 显示分享的弹框
    share() {
      this.dialog_share = true;
    },
    copy() {
      var clipboard = new Clipboard(".copy-code-button"); // 这里可以理解为选择器，选择上面的复制按钮
      clipboard.on("success", (e) => {
        this.$message({
          message: "复制成功",
          type: "success",
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$message.error("此浏览器不支持复制功能");

        // 释放内存
        clipboard.destroy();
      });
    },
    // 双击在线编辑
    dbClickEdit(handlePage, e, type) {
      this.handlePage = handlePage;
      let that = this;
      that.db_select_id = e.target.getAttribute("fanyi");
      // 重置所有属性
      let allDom = Array.from(document.querySelectorAll("[contenteditable]"));
      allDom.forEach((item) => {
        item.setAttribute("contenteditable", false);
      });

      e.target.setAttribute("contenteditable", true);
      e.target.setAttribute("editable", true);

      let beforeTxt = e.target.innerText; // 修改之前的文章

      e.target.onblur = function (e) {
        let txt = e.target.innerText; // 修改之后的文章
        let editHTML = e.target.outerHTML;

        let allDom = Array.from(document.querySelectorAll("[contenteditable]"));
        allDom.forEach((item) => {
          item.setAttribute("contenteditable", false);
        });

        // 内容发生变化再发送接口
        if (beforeTxt != txt) {
          that.postEdit(editHTML, that.db_select_id, type);
        }
      };
    },

    // 编辑译文
    editTranslation() {
      if (!this.select_id) {
        this.$message.error("请选择要编辑的译文段落！");
        return;
      }
      this.dialog_edit = true;
      let dom = document.querySelectorAll(`[fanyi='${this.select_id}']`)[0];
      this.textarea_edit = dom.innerText;
    },
    // 调整在线编辑译文为可编辑状态
    canEditTrans() {
      this.textarea_edit_disable = false;
    },

    // 提交在线编辑译文
    submitEdit() {
      this.postEdit(this.textarea_edit);
    },
    // 发送编辑的请求
    postEdit(data, id, type) {
      this.$http
        .post(
          "translate/edit/",
          this.$qs.stringify({
            task_id: this.$route.query.id,
            fanyi: id,
            content: data,
            page_num: this.handlePage,
            type: type,
          })
        )
        .then((res) => {
          if (res.data.status == 0) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.$http.get("translate/edit/", {
              params: {
                task_id: this.$route.query.id,
              },
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },

    // 译文弹框确定
    yiwen_sure() {
      this.modil.content = this.yiwen_textarea;
      console.log(this.modil);
      this.$message.warning("添加成功，请点击上方确认提交按钮进行修改提交");
      this.dialog_yiwen = false;
      this.modiList.map((item, index) => {
        if (item.fanyi == this.modil.fanyi) {
          this.modiList.splice(index, 1);
        }
      });
      this.modiList.push(this.modil);
    },

    // 修改备注，为可编辑状态
    editNote() {
      console.log(this.textarea_note_disable, "222");
      this.textarea_note_disable = false;
    },

    // 删除当前备注
    delNote() {
      if (!this.delFlag) {
        return;
      }
      this.delFlag = false;
      this.$message({
        message: "操作成功点击确认按钮提交",
        type: "warning",
      });
      let data = {
        task_id: this.$route.query.id,
        fanyi: this.select_id,
        page_num: this.select_page,
        tips: this.textarea_note,
        type: 2, //备注删除代码标识
      };
      this.NodeList.push(data);
      this.dialog_note = false;
      this.delFlag = true;

      // //重复点删除  去重
      // this.NodeList = this.NodeList.filter((currentValue, currentIndex, selfArr) => {
      //     //因为添加修改与删除是两个函数必定有一个是替代掉的
      //     //所以不用考虑 NodeList数组里同事纯在fanyi相等，type不相等的情况
      //     return selfArr.findIndex(x => x.fanyi === currentValue.fanyi) === currentIndex
      // });

      // console.log(this.NodeList)
      // this.$http.get('translate/tips/', {
      //     params: {
      //         task_id: this.$route.query.id,
      //         fanyi: this.select_id,
      //         page_num: this.select_page
      //     }
      // }).then(res => {
      //     this.delFlag = true
      //     if (res.data.status == 0) {
      //         this.$message({
      //             message: '删除成功！',
      //             type: 'success'
      //         });

      //         // 组织数据重新获取HTML
      //         this.uploadHTML()
      //     } else {
      //         this.dialog_note = false
      //         this.$message.error('删除当前备注失败，请稍后再试！')

      //     }
      // }).catch(err => {
      //     this.$message.error(err || '发生错误')
      //     this.delFlag = true
      // })
    },
    // 提交新创建的备注
    submitNode() {
      // 不修改
      if (this.textarea_note_disable) {
        this.dialog_note = false;
        return;
      }
      // 内容没发生变化
      if (this.textarea_note == this.init_note) {
        this.dialog_note = false;
        return;
      }
      let data = {
        task_id: this.$route.query.id,
        fanyi: this.select_id,
        tips: this.textarea_note,
        page_num: this.select_page,
        type: 1, //备注添加修改代码标识
      };
      this.$message({
        message: "操作成功,请点击确认按钮提交",
        type: "warning",
      });
      this.NodeList.push(data);
      // //重复点一个修改去重
      // this.NodeList = this.NodeList.filter((currentValue, currentIndex, selfArr) => {
      //     //因为添加修改与删除是两个函数必定有一个是替代掉的
      //     //所以不用考虑 NodeList数组里同事纯在fanyi相等，type不相等的情况
      //     return selfArr.findIndex(x => x.fanyi === currentValue.fanyi) === currentIndex
      // });
      // console.log(this.NodeList)
      this.dialog_note = false;
      // this.$http.post('translate/tips/', this.$qs.stringify(data)).then(res => {
      //     if (res.data.status == 0) {
      //         this.$message({
      //             message: '添加备注成功！',
      //             type: 'success'
      //         });
      //         // 组织数据重新获取HTML
      //         this.uploadHTML()
      //     }
      // }).catch(err => {
      //     this.$message.error(err || '发生错误')
      // })
    },

    // 更新修改的HTMl
    uploadHTML() {
      // 组织数据重新获取HTML
      let data = {
        task_id: this.$route.query.id,
        page: this.select_page,
        share_id: this.$route.query.share_id,
      };
      this.$http
        .post("translate/handle/", this.$qs.stringify(data))
        .then((res) => {
          this.dialog_note = false;
          this.dialog_merge = false;
          this.merge_loading = false;
          this.showAddbox = false;

          if (res.data.status == 0) {
            this.transPic[this.select_page - 1].html = res.data.data.result;
          } else if (res.data.status == 3) {
            this.dialog_error = true;
            this.error_txt = "当前文件您暂无打开权限！请见谅！";
          } else if (res.data.status == 6) {
            this.dialog_error = true;
            this.error_txt = "当前文件已过期！";
          } else {
            this.dialog_error = true;
            this.error_txt = "文件打开失败，请稍后再试！";
          }
        })
        .catch((err) => {
          this.$message.error(err || "发生错误");
        });
    },

    // 点击了原文区域 清空左侧选择的select_id
    handleOrgin(index, e) {
      let id = e.target.getAttribute("fanyi");
      this.select_page = null;
      this.select_id = null;
      this.merge_next_id = null;
      this.select_id = e.target.getAttribute("fanyi");
      this.select_page = index + 1;
      // console.log( this.select_page,this.select_id)
      // 特定id 添加背景颜色
      let allDom = Array.from(document.querySelectorAll("[fanyi]"));
      if (!this.boxChooseFlag) {
        allDom.forEach((item) => {
          item.style.background = "transparent";
        });

        // 添加特定背景色
        let dom = Array.from(document.querySelectorAll(`[fanyi='${id}']`));
        dom.forEach((item) => {
          item.style.background = "#E5F1BE";
        });
      }
    },

    // 选中了译文段落
    chooseParagraph(page, e) {
      this.select_id = null;
      this.select_page = null;
      this.select_page = page;
      this.select_id = e.target.getAttribute("fanyi");
      // 特定id 添加背景颜色
      let allDom = Array.from(document.querySelectorAll("[fanyi]"));
      // 添加特定背景色
      let dom = Array.from(
        document.querySelectorAll(`[fanyi='${this.select_id}']`)
      );
      // 未选择源样式清空
      if (!this.select_id) {
        allDom.forEach((item) => {
          item.setAttribute("contenteditable", false);
        });
      } else {
        // 记录要合并的兄弟节点的id
        let _dom = document.querySelector(
          `.trans_wrap [fanyi='${this.select_id}']`
        );

        this.merge_next_id = _dom.nextElementSibling
          ? _dom.nextElementSibling.getAttribute("fanyi")
          : null;
      }

      allDom.forEach((item) => {
        item.style.background = "transparent";
      });

      dom.forEach((item) => {
        item.style.background = "#E5F1BE";
      });
      // 当前段落下是否已包含备注
      if (e.target.querySelector("[tips_con]")) {
        this.showAddbox = false;
      } else {
        this.showAddbox = true;
      }

      // 当前选中的是备注标签
      if (e.target.getAttribute("tips_con")) {
        this.textarea_note = e.target.getAttribute("tips_con");
        this.init_note = e.target.getAttribute("tips_con");
        this.select_id = e.target.getAttribute("tips_id");
        this.has_node_txt = true;
        this.textarea_note_disable = true;
        this.dialog_note = true;
        this.showAddbox = false;
      }

      // 添加备注按钮的位置
      let html_box = document.querySelector(".html_main");
      this.addbox_top = e.y + html_box.scrollTop - 230;

      if (this.showFromPDF && this.showToPDF) {
        this.addbox_left =
          e.target.getBoundingClientRect().left +
          e.target.getBoundingClientRect().width;
      } else {
        this.addbox_left =
          (e.target.getBoundingClientRect().width + e.target.offsetLeft) *
          this.zoom;
      }
    },

    // 确认合并下一句
    merge_sure() {
      this.$message.warning("请点击上方确认提交按钮进行合并");
      let fam = [this.select_id, this.merge_next_id];
      // let fam="['" + this.select_id + "','" + this.merge_next_id + "']"

      let data = {
        task_id: this.$route.query.id,
        // fanyi: "['" + this.select_id + "','" + this.merge_next_id + "']",
        fanyi: fam,
        // info: '{"' + this.select_id + '":"'
        //     + this.merge_info['"' + this.select_id + '"']
        //     + '","' + this.merge_next_id
        //     + '":"' + this.merge_info['"' + this.merge_next_id + '"'] + '"}',
        page_num: this.select_page,
      };
      this.mergeList.push(data);
      this.dialog_merge = false;
      this.merge_loading = true;
      // this.$http.post('translate/merge/', this.$qs.stringify({
      //     task_id: this.$route.query.id,
      //     info: '{"' + this.select_id + '":"'
      //      + this.merge_info['"' + this.select_id + '"']
      //      + '","' + this.merge_next_id
      //      + '":"' + this.merge_info['"' + this.merge_next_id + '"'] + '"}',
      //     page_num: this.select_page
      // })).then(res => {

      //     if (res.data.status == 0) {
      //         // 组织数据重新获取HTML
      //         this.uploadHTML()
      //     } else {
      //         this.$message.error(res.msg)
      //         this.dialog_merge = false
      //     }
      // })
    },

    // 鼠标划入添加高亮
    highlight(e) {
      if (this.boxChooseFlag) {
        return;
      }

      let id = e.target.getAttribute("fanyi");

      // 全部清空背景颜色
      let allDom = Array.from(document.querySelectorAll("[fanyi]"));
      allDom.forEach((item) => {
        if (item.style.background == "rgb(207, 232, 204)") {
          item.style.background = "transparent";
        }
      });

      // 特定id 添加背景颜色
      let dom = Array.from(document.querySelectorAll(`[fanyi='${id}']`));
      dom.forEach((item) => {
        item.style.background = "#CFE8CC";
      });
    },

    // 拖拽移动
    dragMove(id, child, type, index) {
      // 进行框选选区操作
      if (this.boxChooseFlag) {
        this.boxChoosePage = index;
        this.boxChoose();
      } else {
        // 拖拽功能

        if (type == "trans") {
          let box_w = document
            .getElementsByClassName("trans_wrap")[0]
            .getBoundingClientRect().width;
          let html_w = document
            .getElementById("pf1")
            .getBoundingClientRect().width;

          if (html_w <= box_w) {
            return;
          }
        } else if (type == "orgin") {
          let box_w = document
            .getElementsByClassName("source_wrap")[0]
            .getBoundingClientRect().width;
          let html_w = document
            .querySelector(".source_wrap #pf1")
            .getBoundingClientRect().width;

          if (html_w <= box_w) {
            console.log("return");
            return;
          }
        }

        let wrap = document.getElementById(id);
        let box = wrap.querySelector(child);
        setTimeout(() => {
          //给绿色的div添加onmousedown事件
          box.onmousedown = function (ev) {
            let e = ev || window.event;
            //计算出鼠标按下的点到box的左侧边缘和上侧边缘
            let restLeft = e.clientX - wrap.offsetLeft - box.offsetLeft;
            let restTop = e.clientY - wrap.offsetTop - box.offsetTop;
            // 针对低版本IE的方法，setCapture方法在oBox元素和下面的元素中间添加了一个透明层
            if (box.setCapture) {
              box.setCapture();
            }

            //移动的时候计算left和top值，这样每次移动都会生效
            document.onmousemove = function (ev) {
              let e = ev || window.event;

              let after_left = e.clientX - wrap.offsetLeft - box.offsetLeft;
              let after_right = e.clientY - wrap.offsetTop - box.offsetTop;

              let distance_x = restLeft - after_left;
              let distance_y = restTop - after_right;

              let offsetLeft = box.offsetLeft;
              let offsetTop = box.offsetTop;

              box.style.left = offsetLeft - distance_x + "px";
              box.style.top = offsetTop - distance_y + "px";

              // 拖拽更改滚动高度的模式

              // wrap.scrollLeft += distance_x
              // wrap.scrollTop += distance_y
            };
            box.onmouseup = function () {
              document.onmousemove = null;
              document.onmouseup = null;
              box.onmouseup = null;
              box.onmousedown = null;

              // 去掉透明层
              if (box.releaseCapture) {
                box.releaseCapture();
              }
            };
            //阻止浏览器默认行为
            return false;
          };
        });
      }
    },

    // 火狐浏览器不支持单独缩放
    getBrowserInfo() {
      var agent = navigator.userAgent.toLowerCase();
      //firefox
      if (agent.indexOf("firefox") > 0) {
        this.isFireFox = true;
      }
    },

    // 弹出框的放大

    popBig() {
      //放大译文全屏展示
      if (this.fullScrenZoom > 1.6) {
        return;
      }
      this.fullScrenZoom += 0.2;
    },
    // 弹出框的缩写
    popSmall() {
      if (this.fullScrenZoom <= 0.8) {
        return;
      }
      this.fullScrenZoom -= 0.2;
    },

    // 对译模式scale参数字体放大
    biger(key) {
      this.showAddbox = false;

      if (this.showFromPDF && this.showToPDF) {
        this[key] += 0.2;
      } else {
        if (this.zoom > 1.6) {
          return;
        }
        this.zoom += 0.2;
      }
      setTimeout(() => {
        if (this.showFromPDF && this.showToPDF) {
          this.img_h = this.$refs.htmlWrap[0].offsetHeight;
        } else {
          if (this.showToPDF) {
            let html_height = document.querySelector("#trans0").offsetHeight;

            this.img_h = html_height * this.zoom;
          } else {
            let html_height = document.querySelector("#orgin0").offsetHeight;

            this.img_h = html_height * this.zoom;
          }

          if (this.$refs.trans_pdf) {
            this.$refs.trans_pdf.scrollTop =
              this.$refs.trans_pdf.scrollTop * (this.zoom - 0.1);
          }
          if (this.$refs.orgin_pdf) {
            this.$refs.orgin_pdf.scrollTop =
              this.$refs.orgin_pdf.scrollTop * (this.zoom - 0.1);
          }
        }
      }, 1000);
    },
    biger_all() {
      if (this.zoom > 1.6) {
          return;
        }
        this.zoom += 0.2;
    },
    smaller_all() {
      if (this.zoom <= 1) {
          return;
        }
        this.zoom -= 0.2;
    },
    // 对译模式scale参数字体缩小
    smaller(key) {
      this.showAddbox = false;

      if (this.showFromPDF && this.showToPDF) {
        if (this[key] < 0.7) {
          return;
        }
        this[key] -= 0.2;
      } else {
        if (this.zoom <= 1) {
          return;
        }
        this.zoom -= 0.2;
      }
      setTimeout(() => {
        if (this.showFromPDF && this.showToPDF) {
          this.img_h = this.$refs.htmlWrap[0].offsetHeight;
        } else {
          if (this.showToPDF) {
            let html_height = document.querySelector("#trans0").offsetHeight;

            this.img_h = html_height * this.zoom;
          } else {
            let html_height = document.querySelector("#orgin0").offsetHeight;

            this.img_h = html_height * this.zoom;
          }

          if (this.$refs.trans_pdf) {
            this.$refs.trans_pdf.scrollTop =
              this.$refs.trans_pdf.scrollTop * (this.zoom - 0.1);
          }
          if (this.$refs.orgin_pdf) {
            this.$refs.orgin_pdf.scrollTop =
              this.$refs.orgin_pdf.scrollTop * (this.zoom - 0.1);
          }
        }
      }, 0);
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件上传之前完善参数
    beforeUpload() {
      this.upload_params.task_id = this.$route.query.id;
    },
    handleChange(file, fileList) {},

    // 点击了展开译文按钮
    handleShowToLang() {
      this.showAddbox = false;

      this.singleScrollTop = this.$refs.orgin_pdf.scrollTop;
      // 要滚动的距离
      let distance;
      // 从双栏对译模式转化需要除以原始缩放系数，滚动到当前视图部分
      if (this.showToPDF && this.showFromPDF) {
        distance = this.singleScrollTop / (this.before_factor + 0.1);
      } else {
        distance = this.singleScrollTop;
      }

      this.showToPDF = true;
      this.showFromPDF = false;
      this.trans_scale_factor = 1;
      setTimeout(() => {
        this.$refs.trans_pdf.scrollTop = distance;

        this.img_h = document.querySelector("#trans0").offsetHeight * this.zoom;
      }, 1000);

      // 将拖拽移动的距离复位
      let domList = Array.from(document.querySelectorAll(".transHtml"));
      domList.forEach((item) => {
        item.style.left = 0;
        item.style.top = 0;
      });
    },
    // 点击了原文版式

    handleShowFromLang() {
      this.showAddbox = false;

      this.singleScrollTop = this.$refs.trans_pdf.scrollTop;
      // 要滚动的距离
      let distance;
      // 从双栏对译模式转化需要除以原始缩放系数，滚动到当前视图部分
      if (this.showToPDF && this.showFromPDF) {
        distance = this.singleScrollTop / (this.before_factor + 0.1);
      } else {
        distance = this.singleScrollTop;
      }
      this.showToPDF = false;
      this.showFromPDF = true;
      this.orgin_scale_factor = 1;

      setTimeout(() => {
        this.$refs.orgin_pdf.scrollTop = distance;
        this.img_h = document.querySelector("#orgin0").offsetHeight * this.zoom;
      }, 1000);

      // 将拖拽移动的距离复位
      let domList = Array.from(document.querySelectorAll(".orginHtml"));
      domList.forEach((item) => {
        item.style.left = 0;
        item.style.top = 0;
      });
    },

    //对照阅读
    handleShowAllLang() {
      this.showAddbox = false;

      if (this.showToPDF) {
        this.singleScrollTop = this.$refs.trans_pdf.scrollTop;
      }
      if (this.showFromPDF) {
        this.singleScrollTop = this.$refs.orgin_pdf.scrollTop;
      }

      this.zoom = 1;
      this.showToPDF = true;
      this.showFromPDF = true;
      this.trans_scale_factor = this.before_factor;
      this.orgin_scale_factor = this.before_factor;
      setTimeout(() => {
        // 直接从放大模式切换到对照阅读模式

        if (this.zoom > 1) {
          this.$refs.orgin_pdf.scrollTop =
            (this.singleScrollTop / (this.zoom - 0.2)) *
            (this.before_factor - 0.1);
          this.$refs.trans_pdf.scrollTop =
            (this.singleScrollTop / (this.zoom - 0.2)) *
            (this.before_factor - 0.1);
          this.img_h = this.$refs.htmlWrap[0].offsetHeight;
        } else {
          // 从800px的尺寸切换回来
          this.$refs.orgin_pdf.scrollTop =
            this.singleScrollTop * (this.before_factor + 0.1);
          this.$refs.trans_pdf.scrollTop =
            this.singleScrollTop * (this.before_factor + 0.1);
          this.img_h = this.$refs.htmlWrap[0].offsetHeight;
        }
        this.zoom = 1;
      }, 0);

      // 将缩放原点重新复位
      this.trans_x = 0;
      this.trans_y = 0;
      this.origin_x = 0;
      this.origin_y = 0;

      // 将拖拽移动的距离复位
      let transDomList = Array.from(document.querySelectorAll(".transHtml"));
      transDomList.forEach((item) => {
        item.style.left = 0;
        item.style.top = 0;
      });
      // 将拖拽移动的距离复位
      let orginDomList = Array.from(document.querySelectorAll(".orginHtml"));
      orginDomList.forEach((item) => {
        item.style.left = 0;
        item.style.top = 0;
      });

      document.querySelector(".source_wrap").style.width = "48%";
      document.querySelector(".trans_wrap").style.width = "48%";
    },

    // 显示手机二维码的弹框
    showCodeDialog() {
      this.codeDialogVisible = !this.codeDialogVisible;
      this.formDialogVisible = false;
    },

    // 插入HTMl 到当前页面
    insertHTml(page) {
      this.insertPage_flag = true;
      //   console.log(this.inputPage)
      //   this.inputPage = page
      if (!this.fullScreenFlag) {
        this.loading = true;
      }
      this.go_top_post = false;

      let data = {
        task_id: this.$route.query.id,
        page: page,
        share_id: this.$route.query.share_id,
      };
      this.$http
        .post("translate/handle/", this.$qs.stringify(data))
        .then((res) => {
          this.loading = false;

          if (res.data.status == 0) {
            this.html_loading = false;

            // 按当前页面插入数据
            this.$set(this.orginPic[page - 1], "index", page);
            this.$set(this.orginPic[page - 1], "html", res.data.data.origin);
            this.$set(this.transPic[page - 1], "index", page);
            this.$set(this.transPic[page - 1], "html", res.data.data.result);
            this.insertPage_flag = false;

            // 当前页面相应回来可以再次请求

            this.$nextTick(() => {
              setTimeout(() => {
                this.go_top_post = true;
              }, 100);
            });
            this.scrollThumbView();
            // console.log("a", this.$refs.trans_pdf.scrollTop);
            // console.log("a", this.$refs.orgin_pdf.scrollTop);
            // console.log("a", this.$refs.pop_con);
            this.$refs.trans_pdf.scrollTop =
              this.$refs.trans_pdf.scrollTop + this.img_h;
            this.$refs.orgin_pdf.scrollTop =
              this.$refs.orgin_pdf.scrollTop + this.img_h;

            let init_h = document.querySelector("#img-box-1")
              ? document.querySelector("#img-box-1").getBoundingClientRect()
                  .height
              : 0;
            // console.log(this.$refs.pop_con);
            if (this.$refs.pop_con) {
              this.$refs.pop_con.scrollTop =
                this.$refs.pop_con.scrollTop + init_h;
            }

            if (this.prevPageFlag) {
              this.$nextTick(() => {
                document
                  .getElementById("img-box-" + this.fullScreenPage)
                  .scrollIntoView();
                this.prevPageFlag = false;
              });
            }
          } else if (res.data.status == 3) {
            this.dialog_error = true;
            this.error_txt = "当前文件您暂无打开权限！请见谅！";
          } else if (res.data.status == 6) {
            this.dialog_error = true;
            this.error_txt = "当前文件已过期！";
          } else {
            this.dialog_error = true;
            this.error_txt = "文件打开失败，请稍后再试！";
          }
        })
        .catch((err) => {
          //   console.log(err);

          this.$message.error(err || "发生错误");
          //   console.log("a");
        });
    },
    async loadPDF(url) {
      try {
        const pdf = await pdfjsLib.getDocument(url).promise;
        const numPages = pdf.numPages; // 获取PDF的总页数

        // 遍历所有页并按顺序渲染
        for (let pageNumber = 1; pageNumber <= numPages; pageNumber++) {
          const page = await pdf.getPage(pageNumber); // 等待获取每一页
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          const viewport = page.getViewport({ scale: 1 });
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          // 渲染当前页面
          await page.render({
            canvasContext: context,
            viewport: viewport,
          }).promise;

          // 将渲染后的canvas元素追加到DOM中
          
          document.getElementById("pdf-viewer").appendChild(canvas);
          setTimeout(() => {
              this.trans_loading = false;
            }, 100);
        }
      } catch (error) {
        console.error("PDF加载失败：", error);
      }
    },
    async loadPDF_(url) {
      try {
        const pdf = await pdfjsLib.getDocument(url).promise;
        const numPages = pdf.numPages; // 获取PDF的总页数

        // 遍历所有页并按顺序渲染
        for (let pageNumber = 1; pageNumber <= numPages; pageNumber++) {
          const page = await pdf.getPage(pageNumber); // 等待获取每一页
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          const viewport = page.getViewport({ scale: 1 });
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          // 渲染当前页面
          await page.render({
            canvasContext: context,
            viewport: viewport,
          }).promise;

          // 将渲染后的canvas元素追加到DOM中
          document.getElementById("pdf-viewer_").appendChild(canvas);
          setTimeout(() => {
              this.orgin_loading = false;
            }, 100);
        }
      } catch (error) {
        console.error("PDF加载失败：", error);
      }
    },
    // 发送请求获取html
    getHTML() {
      this.loadPDF_(
        "http://chatlanguage.cn-beijing.oss.aliyuncs.com/docx%2F20251120%2F17636236338930041099117399556.pdf?x-oss-traffic-limit=25165824&OSSAccessKeyId=LTAI5t5yF1LppFnFUMWgC3i6&Expires=1764228485&Signature=0NuX%2BcohwBdbCygg8I7FagkUbLA%3D"
      );
      this.loadPDF(
        "http://chatlanguage.cn-beijing.oss.aliyuncs.com/request%2Fpdf%2F2025-11-20%2Ff301bc6d6d1b42aab76802d3d8897715%2Ftranslate_17636236338930041099117399556.pdf?x-oss-traffic-limit=25165824&OSSAccessKeyId=LTAI5t5yF1LppFnFUMWgC3i6&Expires=1764228485&Signature=7s8WYWDmmXblfZ1ou4dmrdGb%2FZs%3D"
      );
      return;
      if (!this.fullScreenFlag) {
        this.loading = true;
      }

      if (this.jump_flag) {
        this.loading = true;
      }
      this.html_loading = true;

      let data = {
        task_id: this.$route.query.id,
        page: this.page,
        share_id: this.$route.query.share_id,
      };
      this.$http
        .post("translate/handle/", this.$qs.stringify(data))
        .then((res) => {
          this.loading = false;

          if (res.data.status == 0) {
            this.html_loading = false;
            // 按当前页面插入数据
            this.$set(this.orginPic[this.page - 1], "index", this.page);
            this.$set(
              this.orginPic[this.page - 1],
              "html",
              res.data.data.origin
            );
            this.$set(this.transPic[this.page - 1], "index", this.page);
            this.$set(
              this.transPic[this.page - 1],
              "html",
              res.data.data.result
            );

            // 递归发送请求
            if (this.page > this.pageNum) {
              return;
            } else {
              this.page++;
            }

            // 是输入页码强行跳转的情况
            if (this.jump_flag) {
              // let h = document.querySelectorAll('.htmlWrap')[0].getBoundingClientRect().height // 获取单页高度
              let h;

              if (this.showToPDF) {
                h = document.querySelector("#trans0").offsetHeight;
              } else {
                h = document.querySelector("#orgin0").offsetHeight;
              }

              let arr = this.transPic
                .filter((item) => {
                  return item.html;
                })
                .map((item) => {
                  return item.index;
                });

              let index = arr.indexOf(Number(this.inputPage)); // 输入的页码之前有几个页面

              this.$nextTick(() => {
                setTimeout(() => {
                  if (this.showToPDF) {
                    this.$refs.trans_pdf.scrollTop = index * h;
                  }
                  if (this.showFromPDF) {
                    this.$refs.orgin_pdf.scrollTop = index * h;
                  }
                  this.jump_flag = false;
                }, 200);
              });
            }
          } else if (res.data.status == 3) {
            this.dialog_error = true;
            this.error_txt = "当前文件您暂无打开权限！请见谅！";
          } else if (res.data.status == 6) {
            this.dialog_error = true;
            this.error_txt = "当前文件已过期！";
          } else {
            this.dialog_error = true;
            this.error_txt = "文件打开失败，请稍后再试！";
          }
        })
        .catch((err) => {
          this.$message.error(err || "发生错误");
        });
    },

    // 跟随滚动 并检测是否存在上一页
    handleScroll(e) {
      let scrollTop;
      // 页面滚动距顶部距离
      if (this.$refs.pop_con) {
        scrollTop = this.$refs.pop_con.scrollTop;
      } else if (this.$refs.trans_pdf) {
        scrollTop = this.$refs.trans_pdf.scrollTop;
      } else if (this.$refs.orgin_pdf) {
        scrollTop = this.$refs.orgin_pdf.scrollTop;
      }

      // 检测页面是否向上滚动

      let scroll = scrollTop - this.i;
      this.i = scrollTop;
      let arr = this.transPic
        .filter((item) => {
          return item.index;
        })
        .map((item) => {
          return item.index;
        });

      // 检测页面向上滚动
      if (scroll < 0) {
        // 全屏模式下的向上滚动
        if (this.fullScreenFlag) {
          if (this.fullScreenPage > 2) {
            // 不存在上一页
            if (arr.indexOf(Number(this.fullScreenPage) - 1) == -1) {
              // 一次请求响应之后再进行发送请求
              if (this.go_top_post) {
                this.insertHTml(Number(this.fullScreenPage) - 1);
              }
            }
          }
        } else {
          // 非全屏模式的向上滚动
          if (this.inputPage > 2) {
            // 不存在上一页
            if (arr.indexOf(Number(this.inputPage) - 1) == -1) {
              // 一次请求响应之后再进行发送请求
              if (this.go_top_post) {
                this.insertHTml(Number(this.inputPage) - 1);
              }
            } else {
            }
          } else {
          }
        }
      } else {
        // 向下滚动
        // this.loading = true
      }

      // 关闭右键弹框
      this.rightMenuVisible = false;

      if (this.showToPDF && this.showFromPDF) {
        // 双栏跟随滚动

        if (
          this.scrollTarget == "orgin" &&
          this.showToPDF &&
          e.target.className == "html_main"
        ) {
          if (this.$refs.trans_pdf && this.$refs.orgin_pdf) {
            this.$refs.trans_pdf.scrollTop = this.$refs.orgin_pdf.scrollTop;
          }
        }
        if (
          this.scrollTarget == "trans" &&
          this.showFromPDF &&
          e.target.className == "html_main"
        ) {
          if (this.$refs.trans_pdf && this.$refs.orgin_pdf) {
            this.$refs.orgin_pdf.scrollTop = this.$refs.trans_pdf.scrollTop;
          }
        }
      }

      if (this.scrollTarget == "thumb") {
      }

      // 只显示原文动态修改当前页码
      if (this.showFromPDF && !this.fullScreenFlag) {
        setTimeout(() => {
          // 动态给当前页面赋值
          if (
            this.showFromPDF &&
            this.$refs.orgin_pdf &&
            this.$refs.orgin_pdf.scrollTop > 0
          ) {
            if (!this.img_h) {
              this.img_h = this.$refs.htmlWrap[0].offsetHeight;
            }

            // 没有上一页的情况不需要检测滚动高度计算页码，直接给数值
            if (this.insertPage_flag || this.jump_flag) {
              return;
            } else {
              let arr = this.transPic
                .filter((item) => {
                  return item.index;
                })
                .map((item) => {
                  return item.index;
                });

              let i =
                Math.ceil((this.$refs.orgin_pdf.scrollTop + 10) / this.img_h) -
                1;

              this.inputPage = arr[i];

              if (this.scrollTarget !== "thumb" && this.$refs.thumb_box) {
                this.$refs.thumb_box.scrollTop = (this.inputPage - 1) * 152;
              }
            }
          }
          if (
            this.showFromPDF &&
            this.$refs.orgin_pdf &&
            this.$refs.orgin_pdf.scrollTop == 0
          ) {
            if (this.scrollTarget !== "thumb" && this.$refs.thumb_box) {
              this.$refs.thumb_box.scrollTop = 0;
            }
          }
        }, 500);
      }

      // 只显示译文显示当前页码
      if (this.showToPDF && !this.showFromPDF && !this.fullScreenFlag) {
        if (
          this.showToPDF &&
          this.$refs.trans_pdf &&
          this.$refs.trans_pdf.scrollTop > 0
        ) {
          if (!this.img_h) {
            this.img_h = this.$refs.htmlWrap[0].offsetHeight;
          }

          // 没有上一页的情况不需要检测滚动高度计算页码，直接给数值
          if (this.insertPage_flag || this.jump_flag) {
            return;
          } else {
            let arr = this.transPic
              .filter((item) => {
                return item.index;
              })
              .map((item) => {
                return item.index;
              });

            let i =
              Math.ceil((this.$refs.trans_pdf.scrollTop + 10) / this.img_h) - 1;

            this.inputPage = arr[i];
            if (this.scrollTarget !== "thumb" && this.$refs.thumb_box) {
              this.$refs.thumb_box.scrollTop = (this.inputPage - 1) * 152;
            }
          }
        }

        if (
          this.showToPDF &&
          this.$refs.trans_pdf &&
          this.$refs.trans_pdf.scrollTop == 0
        ) {
          if (this.scrollTarget !== "thumb" && this.$refs.thumb_box) {
            this.$refs.thumb_box.scrollTop = 0;
          }
        }
      }

      // 全屏模式下检测页码的变化
      if (this.fullScreenFlag) {
        this.$nextTick(() => {
          let init_h = document.querySelector("#img-box-1")
            ? document.querySelector("#img-box-1").getBoundingClientRect()
                .height
            : 0;
          let fullScreen_h = init_h * this.fullScrenZoom;

          let arr = this.transPic
            .filter((item) => {
              return item.index;
            })
            .map((item) => {
              return item.index;
            });

          if (this.$refs.pop_con) {
            let i =
              Math.ceil((this.$refs.pop_con.scrollTop + 10) / fullScreen_h) - 1;

            this.fullScreenPage = arr[i];
          }
        });
      }
    },

    //鼠标进入缩略图
    enterThumb() {
      this.scrollTarget = "thumb";
    },

    // 鼠标进入左侧栏
    enterOrgin(index, e) {
      this.scrollTarget = "orgin";
      // this.inputPage = index + 1
      // this.origin_x = 0
      // this.origin_y = 0
      // this.trans_x = 0
      // this.trans_y = 0
    },
    // 鼠标进入右侧栏
    enterTrans(index, e) {
      this.scrollTarget = "trans";
      // this.inputPage = index + 1
      // this.origin_x = 0
      // this.origin_y = 0
      // this.trans_x = 0
      // this.trans_y = 0
    },
    mouseMove(e) {
      // console.log(e)
    },

    // 上一页
    subPage() {
      this.inputPage <= 1 ? 1 : this.inputPage--;
      this.scrollView();
    },

    // 下一页
    addPage() {
      this.inputPage >= this.pageNum ? this.pageNum : this.inputPage++;
      this.scrollView();
    },

    // 直接改变输入框的页码
    changeInputPage() {
      if (
        this.inputPage < 0 ||
        this.inputPage == 0 ||
        this.inputPage > this.pageNum
      ) {
        this.$message.error("请输入正确的页码");
        this.inputPage = 1;
        return;
      }
      // 获取当前存在的页码
      let page_list = this.transPic.map((item) => {
        return item.index;
      });

      // 不存在该页面
      if (page_list.indexOf(Number(this.inputPage)) == -1) {
        this.jump_flag = true;
        this.page = Number(this.inputPage);
        this.getHTML();
        // this.insertHTml(Number(this.inputPage))
      } else {
        // 存在要跳转的页面

        this.calScrollTop();
      }
    },

    // 计算距离头部的滚动距离
    calScrollTop() {
      let h = this.img_h;

      let arr = this.transPic
        .filter((item) => {
          return item.index;
        })
        .map((item) => {
          return item.index;
        });

      let index = arr.indexOf(Number(this.inputPage));
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.showToPDF) {
            this.$refs.trans_pdf.scrollTop = index * h;
          }
          if (this.showFromPDF) {
            this.$refs.orgin_pdf.scrollTop = index * h;
          }
        }, 0);
      });

      this.scrollThumbView();
    },

    scrollView() {
      if (this.showFromPDF) {
        document
          .getElementById("orgin" + (this.inputPage - 1))
          .scrollIntoView({ behavior: "smooth" });
      }
      if (this.showToPDF) {
        document
          .getElementById("trans" + (this.inputPage - 1))
          .scrollIntoView({ behavior: "smooth" });
      }
    },

    // 下载操作
    handleDownLoad(version, type) {
      let down_id = {
        // task_id: "['" + id + "']",
        // version: version,
        // type: type,
        task_id: this.task_id_copy,
        type:
          version == "translate"
            ? type == "pdf"
              ? "2"
              : "4"
            : version == "origin"
            ? "1"
            : version == "compare"
            ? "3"
            : "1",
      };
      // download(down_id)
      download_ql(down_id)
        .then((res) => {
          console.log(res);
          if (res.data.error_code == 0) {
            if (res.data.data) {
              window.open(res.data.data, "_blank");
            } else {
              this.$message.error("暂无文件！");
            }

           
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
      // this.$http
      //   .post(
      //     "translate/download/",
      //     this.$qs.stringify({
      //       task_id: "['" + this.$route.query.id + "']",
      //       version: version,
      //       type: type,
      //     })
      //   )
      //   .then((res) => {
      //     if (res.data.data[0].status == 0) {
      //       window.open(res.data.data[0].url);
      //     } else {
      //       this.$message.error("下载失败");
      //     }
      //   })
      //   .catch((err) => {
      //     this.$message.error("请登录账号下载译文");
      //   });
    },

    // 提交反馈表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http
            .post(
              "translate/feedback/",
              this.$qs.stringify({
                p_a: this.value,
                p_b: this.form.p_b,
                task_id: this.$route.query.id,
                email: this.form.email,
                qq: this.form.qq,
                allow: this.form.allow ? 1 : 0,
              })
            )
            .then((res) => {
              if (res.data.status == 0) {
                this.fileList = [];
                this.formDialogVisible = false;
                this.dialog_feedback = true;
                this.feedback_txt = "你的反馈已提交成功!";
              } else {
                this.fileList = [];
                this.formDialogVisible = false;
                this.dialog_feedback = true;
                this.feedback_txt = "提交失败,请稍后再试!";
              }
            })
            .catch((err) => {
              this.$message.error(err || "发生错误");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 文件上传成功
    uploadSuccess(res) {},
    uploadFail(err, file, fileList) {
      this.$message.error(err);
    },
    // 更改译文和原文位置
    changeOrder() {
      if (this.order == 0) {
        this.order = 3;
      } else {
        this.order = 0;
      }
    },
    // 获取缩略图
    getThumb() {
      return;
      this.$http
        .get("translate/catalog/", {
          params: {
            task_id: this.$route.query.id,
          },
        })
        .then((res) => {
          if (res.data.status == 0) {
            this.thumbImg = res.data.data.img;
          }
        });
    },
    // 切换是否显示缩略图
    switchThumb() {
      this.thumbFlag = !this.thumbFlag;

      if (this.showToPDF && this.showFromPDF) {
        setTimeout(() => {
          let trans_box_w =
            document.getElementsByClassName("trans_wrap")[0].offsetWidth;
          let source_box_w =
            document.getElementsByClassName("source_wrap")[0].offsetWidth;
          let max = Math.max(trans_box_w, source_box_w);
          this.html_w = document.getElementById("pf1").offsetWidth;

          this.scale_factor = max / this.html_w;
          this.orgin_scale_factor = this.scale_factor;
          this.trans_scale_factor = this.scale_factor;

          this.before_factor = this.scale_factor;

          this.$nextTick(() => {
            setTimeout(() => {
              this.img_h = this.$refs.htmlWrap[0].offsetHeight;
            }, 100);
          });
        }, 500);
      }
    },

    // 点击了某条缩略图
    handleThumb(i) {
      this.inputPage = i + 1;

      // 获取当前存在的页码
      let page_list = this.transPic.map((item) => {
        return item.index;
      });

      // 不存在该页面
      if (page_list.indexOf(Number(this.inputPage)) == -1) {
        this.jump_flag = true;
        this.page = Number(this.inputPage);
        // this.insertHTml(Number(this.inputPage))
        this.getHTML();
      } else {
        // 存在要跳转的页面
        this.calScrollTop();
      }
    },
    // 关闭全屏显示
    closePop() {
      this.fullScreenFlag = false;
      this.fullScrenZoom = 1;
    },
    // 全屏模式
    openFullScreen() {
      this.fullScreenFlag = true;
      this.fullScreenPage = this.select_page;

      this.$nextTick(() => {
        setTimeout(() => {
          document
            .getElementById("img-box-" + this.fullScreenPage)
            .scrollIntoView();
        }, 0);
      });
    },
    // 更改全屏模式的译文还是原文
    changePopType() {
      if (this.rightMenuType == "trans") {
        this.rightMenuType = "orgin";
      } else if (this.rightMenuType == "orgin") {
        this.rightMenuType = "trans";
      }
    },

    // 点击上一页
    prevPage() {
      if (this.fullScreenPage == 1) {
        return;
      }

      let arr = this.transPic
        .filter((item) => {
          return item.index;
        })
        .map((item) => {
          return item.index;
        });
      if (arr.indexOf(this.fullScreenPage - 1) == -1) {
        // 一次请求响应之后再进行发送请求
        if (this.go_top_post) {
          this.prevPageFlag = true;
          this.fullScreenPage--;
          this.insertHTml(Number(this.fullScreenPage));
        }
      } else {
        this.fullScreenPage--;
        document
          .getElementById("img-box-" + this.fullScreenPage)
          .scrollIntoView();
      }
    },

    // 点击下一页
    nextPage() {
      if (this.html_loading) {
        return;
      }
      if (this.fullScreenPage == this.pageNum) {
        return;
      }

      this.fullScreenPage++;
      if (document.getElementById("img-box-" + this.fullScreenPage)) {
        document
          .getElementById("img-box-" + this.fullScreenPage)
          .scrollIntoView();
      }
    },

    //弹出框旋转
    popRotate() {
      let degStr = document.getElementById("img-box-" + this.fullScreenPage)
        .style.transform;
      // 判断是否存在旋转角度
      if (!degStr) {
        document.getElementById(
          "img-box-" + this.fullScreenPage
        ).style.transform = "rotate(-90deg)";
      } else {
        // 存在旋转角度再加90度
        let deg = degStr.replace(/[^\d]/g, "");
        let newdeg = -deg - 90;
        document.getElementById(
          "img-box-" + this.fullScreenPage
        ).style.transform = `rotate(${newdeg}deg)`;
      }
    },
    handleDownloadType(val) {
     
      if (val) {
        this.handleDownLoad(val[0], val[1]);
        return
        if (val.length == 1) {
          this.handleDownLoad(val[0], val[1]);
        } else {
          this.$http
            .post(
              "translate/search_contrast/",
              this.$qs.stringify({
                task_id: this.$route.query.id,
              })
            )
            .then((res) => {
              var s = res.data.data;
              if (val[0] == "translate" && val[1] == "pdf") {
                if (s.pdf_translate_result == 1) {
                  this.handleDownLoad(val[0], val[1]);
                } else {
                  if (s.pdf_translate_result == 0) {
                    this.$message.error("正在处理中");
                  } else {
                    this.$message.error("处理失败");
                  }
                }
              } else if (val[0] == "translate" && val[1] == "word") {
                if (s.word_translate_result == 1) {
                  this.handleDownLoad(val[0], val[1]);
                } else {
                  if (s.word_translate_result == 0) {
                    this.$message.error("正在处理中");
                  } else {
                    this.$message.error("处理失败");
                  }
                }
              } else if (val[0] == "origin" && val[1] == "pdf") {
                if (s.pdf_origin_result == 1) {
                  this.handleDownLoad(val[0], val[1]);
                } else {
                  if (s.pdf_origin_result == 0) {
                    this.$message.error("正在处理中");
                  } else {
                    this.$message.error("处理失败");
                  }
                }
              } else if (val[0] == "origin" && val[1] == "word") {
                if (s.word_origin_result == 1) {
                  this.handleDownLoad(val[0], val[1]);
                } else {
                  if (s.word_origin_result == 0) {
                    this.$message.error("正在处理中");
                  } else {
                    this.$message.error("处理失败");
                  }
                }
              }
            });
        }

        // this.handleDownLoad(val[0], val[1])
      }
      this.cascaderValue = null;
      let obj = {};
      obj.stopPropagation = () => {};
      try {
        this.$refs.cascader.clearValue();
      } catch (err) {
        this.$refs.cascader.handleClear();
      }
    },
  },
};
</script>
<style lang='less' scoped>
.pdf_top_bg {
  background: #014d6f;
  background: #f1f5ff;

  min-width: 1100px;
}

.pdf_top {
  display: flex;
  margin: 0 auto;
  height: 50px;
  color: #fff;
  color: #555555;

  .lang_page {
    display: flex;
    width: 580px;
    height: 50px;

    margin-left: auto;
    align-items: center;

    .page {
      display: flex;
      height: 50px;
      margin-left: 30px;
      align-items: center;
    }

    .page_num_wrap {
      display: flex;
      border-radius: 4px;
      margin: 0 10px;
      background: #fff;
    }

    .page_num_input {
      width: 60px;
    }

    .page_num_arrow {
      width: 24px;
      height: 28px;
      line-height: 4px;
      text-align: center;
      color: #333;
    }
  }

  .rignt_btn {
    display: flex;
  }

  .right_btn_item {
    position: relative;
    line-height: 50px;
    margin-right: 20px;
    cursor: pointer;
  }
}

.double_pdf {
  display: flex;
  height: calc(100vh - 150px);
  min-width: 1100px;
  align-items: center;
  background: #525659;
}

.pdf_wrap {
  flex: 1;
  display: inline-block;
  width: 48%;
  height: 100%;

  .pdf_box_wrap {
    margin: 2%;
  }

  .orgin_pdf_box,
  .trans_pdf_box {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: calc(100vh - 170px);
    min-width: 420px;
    max-width: 1000px;
    margin: 0px auto;
    // padding: 10px;
    overflow: auto;

    img {
      width: 100%;
      min-width: 420px;
    }
  }
}

.middle {
  position: fixed;
  top: 50%;
  display: flex;
  flex: none;
  flex-direction: column;
  width: 4%;
  justify-content: center;
  align-items: center;

  .icon_wrap {
    border-radius: 50%;
    width: 30px;
    height: 30px;
    margin-bottom: 20px;
    text-align: center;
    line-height: 30px;
    background: #083168;
    color: #fff;
  }

  .icon-xiangzuo1 {
    font-size: 16px;
  }

  .step_left {
    transform: rotate(180deg);
  }

  .format_btn {
    text-align: center;
    color: #fff;
    line-height: 26px;

    .iconfont {
      font-size: 30px;
    }
  }
}

.code_wrap {
  text-align: center;

  .code_img {
    width: 100px;
  }

  p {
    margin-top: 20px;
    font-size: 17px;
  }
}

.switch_item {
  /deep/.el-form-item__label {
    width: 0px !important;
  }
}

.fixed_wrap {
  position: fixed;
  right: 30px;
  bottom: 200px;
  color: #09376e;

  .iconfont {
    font-size: 17px;
  }

  p {
    margin-top: 10px;
  }

  .fixed_arrow {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    margin: 20px auto;
    line-height: 40px;
    text-align: center;
    font-weight: 700;
    font-size: 18px;
    color: #525659;
    background: #fff;
    cursor: pointer;
  }

  .show_to_lang {
    text-align: center;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .show_from_lang {
    text-align: center;
    cursor: pointer;
  }
}

.icon_sus {
  color: #52c41a;
}

// html 格式展示
.html_wrap {
  min-width: 1100px;
  height: calc(100vh - 169px);
  // overflow: hidden;

  .html_inner_wrap {
    position: relative;
    display: flex;
    height: calc(100vh - 129px);

    min-width: 1000px;
    padding: 0 20px 20px 20px;
    justify-content: space-between;
    background: #f1f5ff;
    overflow: auto;

    .source_wrap,
    .trans_wrap {
      position: relative;
      height: 100%;
      width: 48%;
      min-width: 240px;
      padding-top: 50px;
      background: #fff;
      overflow: auto;

      li {
        // background: #fff;
      }
    }

    .title {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;

      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 20px;
      padding-left: 10px;
      z-index: 2;

      .line {
        display: inline-block;
        width: 4px;
        height: 18px;
        background: #3390ff;
        margin-right: 15px;
        position: relative;
        top: 4px;
      }

      .title_l {
        font-size: 18px;
        font-weight: 700;
      }

      .title_r {
        position: relative;
        height: 24px;

        .iconfont {
          font-size: 18px;
          margin-right: 10px;
          color: #666;
          cursor: pointer;
        }

        .drawAreaIcon {
          position: absolute;
          right: 0px;
          top: 0;
          z-index: 10;
        }
      }
    }
  }
}

// .html_inner_wrap::-webkit-scrollbar {
//     /*滚动条整体样式*/
//     width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
//     height: 1px;
// }
// .html_inner_wrap::-webkit-scrollbar-thumb {
//     /*滚动条里面小方块*/
//     border-radius: 10px;
//     box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//     background: #afafaf;
// }
// .html_inner_wrap::-webkit-scrollbar-track {
//     /*滚动条里面轨道*/
//     box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//     border-radius: 10px;
//     background: #ededed;
// }
// .htmlWrap::-webkit-scrollbar {
//     /*滚动条整体样式*/
//     width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
//     height: 6px;
// }
// .htmlWrap::-webkit-scrollbar-thumb {
//     /*滚动条里面小方块*/
//     border-radius: 10px;
//     box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//     background: #bbb;
// }
// .htmlWrap::-webkit-scrollbar-track {
//     /*滚动条里面轨道*/
//     box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//     border-radius: 10px;
//     background: #ededed;
// }

.hover {
  background: #ecf2d8;
}

.orginHtml,
.transHtml {
  position: relative;
  left: 0;
  top: 0;
  transform-origin: 0 0;
}

.white {
  background: #fff;
}

.lang {
  // margin-left: 80px;
}

.htmlWrap {
  position: relative;
  border-bottom: 8px solid #f1f5ff;
  overflow: auto;
  transform-origin: 0 0;
}

.center {
  justify-content: center !important;
}

.w_auto {
  width: auto !important;
}

.icon-cuowu {
  color: red;
  margin-right: 10px;
}

.dialog_error {
  font-size: 15px;
}

.rel_li {
  height: calc(100vh - 150px);
  overflow: auto;
}

/deep/ .el-dropdown-menu__item {
  padding: 0;

  span {
    padding: 0 20px;
    line-height: 30px;
  }
}

.html_main {
  position: relative;
  height: 100%;
  overflow: auto;

  .addbox {
    border-radius: 50%;
    position: absolute;
    z-index: 10;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #014d6f;
    background: #014d6f;
    color: #fff;
    cursor: pointer;
  }
}

.html_main::-webkit-scrollbar {
  /* Chrome Safari */
  display: none;
}

.html_main {
  scrollbar-width: none;
  /* Firefox */
}

.html_main {
  -ms-overflow-style: none;
  /* IE 10+ */
}

.html_main .htmlWrap {
  -ms-overflow-style: scrollbar;
  /* IE 10+ */
}

.page_num {
  width: 40px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #fff;
  border-radius: 4px;
}

// 添加标注的标题
.dialog_note_title {
  display: flex;
  justify-content: space-between;

  .dialog_note_title_l {
    font-size: 16px;
    font-weight: 700;
  }

  .dialog_note_title_r {
    .iconfont {
      font-size: 22px;
      padding: 0 4px;
      cursor: pointer;
    }
  }
}

.el_textarea {
  margin-top: 10px;
}

/deep/ [contenteditable="true"] {
  caret-color: #000;
  border: 3px solid #666;
}

.dialog_merge_box {
  .dialog_merge_title {
    font-size: 15px;
    font-weight: 700;
    margin-top: -20px;
    margin-bottom: 10px;
  }

  .merge_p {
    margin-bottom: 10px;
    color: red;
    line-height: 1.5;
  }

  span {
    color: #aaa;
  }
}

.merge_loading_p {
  padding: 0 20px;
}

/deep/[tips_con] {
  background: url("../../assets/imgs/tip1.png") no-repeat !important;
  background-size: 74px 74px !important;
  cursor: pointer;
}

.share_title {
  line-height: 2;
  font-size: 16px;
}

.share_link_box {
  line-height: 1.6;

  .copy-code-button {
    color: red;
    cursor: pointer;

    .iconfont {
      font-size: 18px;
    }
  }
}

.contextmenu {
  position: fixed;
  z-index: 3000;
  border-radius: 4px;
  margin: 0;
  padding: 5px 0;
  font-size: 12px;
  font-weight: 400;
  list-style-type: none;
  color: #333;
  background: #fff;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
}

.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;

  .iconfont {
    margin-right: 10px;
  }
}

.contextmenu li:hover {
  background-color: rgb(3, 125, 243);
  color: white;
}

.splitDragResize {
  position: relative;
  height: 100%;
  width: 5px;
  cursor: col-resize;
  float: left;
  background: #ccc;
}

.splitDragResize:active {
  width: 10px;
  background: #3390ff;
}

img {
  -webkit-user-drag: none;
}

// // 缩略图相关样式
// .thumb_btn {
//   position: absolute;
//   top: 56%;
//   left: 0px;

//   -webkit-transform: translateY(-50%);
//   -ms-transform: translateY(-50%);
//   transform: translateY(-50%);
//   height: 38px;
//   width: 18px;
//   line-height: 38px;
//   border-radius: 0 200px 200px 0;
//   background-color: #8d8a82;
//   z-index: 3;
//   cursor: pointer;
// }

.icon-triangle {
  color: #fff;
}

.thumb_icon {
  display: inline-block;
  transform: rotate(180deg);
}

.thumb_side {
  position: relative;
  width: 160px;
  overflow-y: auto;
  background-color: #f6f6f6;
  outline: none;
  height: 100%;
}

.view_list {
  position: relative;
  counter-reset: section;
  width: 100%;
  padding: 0 8px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: rgba(0, 0, 0, 0);
}

.img_box {
  position: relative;
  margin: 8px 0;
  background-color: #f7f7f7;
  cursor: pointer;
  width: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &::before {
    bottom: 8px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    counter-increment: section;
    content: counter(section);
    position: absolute;
    border-radius: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    left: 50%;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.2);
    color: #fff;
    pointer-events: none;
    z-index: 1;
  }

  &.cur::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border: 1px solid #ff9a8b;
    -webkit-box-shadow: 0 0 10px 0 rgb(0 0 0 / 10%);
    box-shadow: 0 0 10px 0 rgb(0 0 0 / 10%);
  }

  img {
    width: 100%;
    height: auto;
    margin: 0;
    vertical-align: middle;
  }
}

// 全屏展示的相关样式
.mod-pop-doc {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.3);
}

.btn-page-prev,
.btn-page-next {
  position: absolute;
  z-index: 99;
  width: 54px;
  height: 54px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.2);
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

.btn-page-prev {
  left: 20px;
}

.btn-page-next {
  right: 20px;
  transform: rotate(180deg);
}

.mod-pop-doc .iconfont {
  color: #fff;

  font-size: 24px;
}

.btn-close {
  position: absolute;
  top: 100px;
  right: 20px;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
.num {
  text-align: center;
  background: #f1f5ff;
  color: red;
}
.group {
  height: 217px;
  width: 54px;
  position: absolute;
  top: 160px;
  right: 20px;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 100px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.btn-big,
.btn-small,
.btn-rotate,
.btn-change {
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.btn-small,
.btn-rotate,
.btn-change {
  border-top: 1px solid hsla(0, 0%, 71%, 0.2);
  flex: 1;
}

.pop-con {
  // padding: 0 80px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
}

.view-list {
  position: relative;
  counter-reset: section;
  margin: 0 auto;
  max-width: 100%;
  // width: 800px;
  background-color: rgba(0, 0, 0, 0);
}

.img-box {
  position: relative;
  margin: 0 auto 30px;

  .pageNum {
    width: 28px;
    height: 28px;
    line-height: 28px;
    font-size: 16px;
    bottom: 20px;
    counter-increment: section;
    content: counter(section);
    position: absolute;
    border-radius: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    left: 50%;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.2);
    color: #fff;
    pointer-events: none;
    z-index: 1;
  }
}

// 原文不进行选择文本
// .no_select {
//     -webkit-touch-callout: none;
//     -webkit-user-select: none;
//     -khtml-user-select: none;
//     -moz-user-select: none;
//     -ms-user-select: none;
//     user-select: none;
// }
// /deep/[fanyi] {
//     background:#ccc;
// }
// /deep/.orginHtml div {
//     background:#ccc
// }

.drawActive {
  color: #d90013 !important;
}

.down_box {
  position: relative;
}

/deep/ .el-cascader .el-input {
  opacity: 0;
  width: 46px;
}

.pdf_xiazai {
  position: absolute;
  left: 0;
  top: 0px;
  z-index: 0;
}

.z-index {
  position: relative;
  z-index: 100;
}
.system {
  // max-width: 1000px;
  // margin: auto;
  height: 80px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
  padding: 0 24px;
  box-sizing: border-box;

  .organName {
    font-size: 24px;
    color: #000;
    font-style: initial;
    font-family: DingTalk-JinBuTi;
  }

  .systemName {
    font-size: 14px;
    color: #e2426b;
    font-style: initial;
    font-family: DingTalk-JinBuTi;
  }
}
.top_bag {
  background: #fff;
  margin: auto;
}
</style> 